export const skillsData = {
  AI: {
    title: "Artificial Intelligence (AI)",
    // color: "bg-red-600",
    children: {
      Module1: {
        title: "Module 1: Towards AI, Data Science",
        children: [
          {
            title: "WEEK 1 -- Exercise, Document and Study Guide",
            key: "m1w1",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Trao Đổi Học Tập",
            key: "m1l1",
            video: "https://www.dropbox.com/scl/fi/96cgf9s413l4yujyp14a3/290524_MT-Zoom.mp4?rlkey=rj4lcc2j4yqe139ony6vv8pkt&st=hhlrvvrt&raw=1",
            document: [
              
            ],
          },
          // {
          //   title: "Hướng dẫn về Git và các quy định quy trình trong [ Quy chế Kiểm Tra Học Tập]",
          //   key: "m1l2",
          //   video: " ",
          //   document: [
          //     {
          //       title: "",
          //       link: "",
          //       linkDownload:"",
          //       view: false,
          //     },
          //   ],
          // },
          {
            title: "Lesson 1.1: Skills for Programmers; If-Else; For loop",
            key: "m1l3",
            video: "https://www.dropbox.com/scl/fi/j3ofucjf6mke1x6d5nth3/M01EC03-Skills-for-Programmers-If-Else-For-loop-Zoom.mp4?rlkey=jnbyajkbywo2rufnucpzpi83n&st=rni0130t&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.2: Basic Python (Branching~Rule-based Chatbot)",
            key: "m1l4",
            video: "https://www.dropbox.com/scl/fi/rnmd8tkx9n2z29p8tp16z/_M01MC-Basic-Python-Branching.Rule-based-Chatbot-Zoom.mp4?rlkey=nnht6xlcup7zva1tvhclbenov&st=1sx2x1kg&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.3: Basic Python (String and Loops~Text preprocessing)",
            key: "m1l5",
            video: "https://www.dropbox.com/scl/fi/7sdnc79g0smyfz8tsn9ar/_M01MC-Basic-Python-String-and-Loops.Text-preprocessing-Zoom.mp4?rlkey=894tr2h6cv7rmwdlm6zerqbo1&st=nqmxywq6&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.4: Ôn python - cực kỳ cơ bản",
            key: "m1l6",
            video: "https://www.dropbox.com/scl/fi/thb4ea0mivnoxsreqdtd4/n-python-c-c-k-c-b-n-live-tr-c-ti-p-code-kh-ng-slide-Zoom.mp4?rlkey=e4depo8pwyv8da3tzywaihatq&st=3sn2ptb3&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.5: TA-Exercise (activation functions)",
            key: "m1l7",
            video: "https://www.dropbox.com/scl/fi/96cgf9s413l4yujyp14a3/290524_MT-Zoom.mp4?rlkey=rj4lcc2j4yqe139ony6vv8pkt&st=05j9sk5w&dl=0",
            document: [
              
            ],
          },
          {
            title: "WEEK 2 -- Exercise, Document and Study Guide",
            key: "m1w2",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.6: List",
            key: "m1l8",
            video: "https://www.dropbox.com/scl/fi/ac5ecvaj5xmhh59o6yg4i/M01EC03-LIST-Zoom.mp4?rlkey=vkr5wpyqn5gm7x8bjwjxqirjz&st=8phoge2k&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.7: Data Structure (list~IoU, Top-K Searching)",
            key: "m1l9",
            video: "https://www.dropbox.com/scl/fi/w71hkajgc0v9zwbc604o0/_M01MC-Data-Structure-list.IoU-Top-K-Searching-Zoom.mp4?rlkey=6wdp894gc561p2mp8f6cerv83&st=2r37e129&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.8: Introduction",
            key: "m1l10",
            video: "https://www.dropbox.com/scl/fi/idfx5tklgpf3tnbjhujm4/M01MC-Lesson-1-Introduction-Zoom.mp4?rlkey=8gqccbim8gff2v21hullf02o8&st=97420y6a&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.9: Data Structure (Non-maximum supression and Histogram)",
            key: "m1l11",
            video: "https://www.dropbox.com/scl/fi/7failr6wt0xkiqhgclcc2/M01MC-Data-Structure-Non-maximum-supression-and-Histogram-Zoom.mp4?rlkey=tbrj0cd5cveeleycm2qypoem9&st=49s3jj4z&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.10: Searching and Sorting Algorithms",
            key: "m1l12",
            video: "https://www.dropbox.com/scl/fi/t5g3aqfes2vsdrd7x88ub/M01EC07-Searching-and-Sorting-Algorithms-Zoom.mp4?rlkey=3hfblf2gsu39n2i5j1suceweg&st=m7l5prb3&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.11: TA-Exercise (Word Suggestion)",
            key: "m1l13",
            video: "https://www.dropbox.com/scl/fi/hwc2emyxzd78hy5g814hy/M01MC-TA-Exercise-Word-Suggestion-Zoom.mp4?rlkey=zfytc2wupndee1zjol6ps9qdm&st=qkcjpgq5&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 3 -- Exercise, Document and Study Guide",
            key: "m1w3",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.12: Classes and Objects (updated v4)",
            key: "m1l14",
            video: "https://www.dropbox.com/scl/fi/ohp1w57jodgk380re2eqy/M01EC03-Classes-and-Objects-Zoom.mp4?rlkey=qi4f5h2syfpsz5i4zsrj9c4ig&st=h2cpasgl&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.13: OOP with Python (Stack Implemetation)",
            key: "m1l15",
            video: "https://www.dropbox.com/scl/fi/k2zhr2knwjiqi07klqqyq/M01MC-OOP-with-Python-Custom-PyTorch-Class-OOP-with-Python-Stack-Implemetation-Zoom.mp4?rlkey=irjd2lcqndc3wiyfxxf7dlqfk&st=jvy7txls&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.14: Data Visualization",
            key: "m1l16",
            video: "https://www.dropbox.com/scl/fi/0wanqu1cw4q922sw32tge/M01EC05-Lesson-2-Data-Visualization-Zoom.mp4?rlkey=ut7s6u3gd9y197vgk5y01duor&st=bgif6nd1&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.15: OOP with Python (Custom PyTorch Class)",
            key: "m1l17",
            video: "https://www.dropbox.com/scl/fi/81jlakfpt78l8hqt1g72l/M01MC-OOP-with-Python-Custom-PyTorch-Class-Lesson2-Zoom.mp4?rlkey=wleg2it8b9m59hlad3q6sn2lu&st=kijs6y0p&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.16: Tree and KDTree",
            key: "m1l18",
            video: "https://www.dropbox.com/scl/fi/rx4eaktcar9sr6w7uyq28/M01EC07-Tree-and-KDTree-Zoom.mp4?rlkey=fma99011igsj7zop18hb375uz&st=6q0g8v9w&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.17: TA-Exercise",
            key: "m1l19",
            video: "https://www.dropbox.com/scl/fi/vwufowb0pmlwgieanzl4y/M01MC-Exercise-Zoom.mp4?rlkey=8lnj8p9xfbf2649gm9g7rpgth&st=si9n1ke7&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 4 -- Exercise, Document and Study Guide",
            key: "m1w4",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.18: Review Module 1",
            key: "m1l20",
            video: "https://www.dropbox.com/scl/fi/wrdwl4b3kgqt20qj2i222/M01EC03-Review-Module-1-Zoom.mp4?rlkey=moajz1xeuc91p6727hyufbzjz&st=3h2ztc3y&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.19: Common Python Libraries (streamlit for deployment)",
            key: "m1l21",
            video: "https://www.dropbox.com/scl/fi/f7jb5h28gy8vu6gemqmvm/M01MC-Common-Python-Libraries-streamlit-for-deployment-Zoom.mp4?rlkey=wd2dir9kh0ix5oqe9mqzo7yxg&st=6a1ubbv3&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.20: Linear Regression and Competition 1 (AIO-level Kaggle)",
            key: "m1l22",
            video: "https://www.dropbox.com/scl/fi/aggpzshl2hpvhyyp0jka7/M01EC05-Lesson-3-Linear-Regression-and-Competition-1-AIO-level-Kaggle-Zoom.mp4?rlkey=pgk0glt3dl1lu1856zygolr5w&st=90rnkeyp&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.21: Text Project: QA with PDF files (--> Large Language Models)",
            key: "m1l23",
            video: "https://www.dropbox.com/scl/fi/bopzal5hncwr43ztzntk0/M01MC-Text-Project-QA-with-PDF-files-Large-Language-Models-Zoom.mp4?rlkey=d6c49umtafg2sg2ft0sj12gby&st=0odi8tz0&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 5 -- Exercise, Document and Study Guide",
            key: "m1w5",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.22: Buổi trao đổi chuẩn bị học tập chuẩn bị module 2, tư vấn định hướng ",
            key: "m1l24",
            video: "https://www.dropbox.com/scl/fi/oxtxvv539ig0gyhp1fp1u/Bu-i-trao-i-chu-n-b-h-c-t-p-chu-n-b-module-2-Zoom.mp4?rlkey=ndmqbjbwv1tooreyzh67m5mg9&st=smojugkx&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 1.23: Seminar [ Du học - và cơ hội ]",
            key: "m1l25",
            video: "https://www.dropbox.com/scl/fi/sdwkdcdp8uub3gz399vtm/Seminar-Du-h-c-v-c-h-i-Zoom.mp4?rlkey=thncdgajj054ezvufiq2bz4p5&st=eurqyizq&raw=1",
            document: [
              
            ],
          },
          // {
          //   title: "Seminar[ Bổ trợ kiến thức về Kinh Doanh - Khởi Nghiệp ]",
          //   key: "m1l26",
          //   video: " ",
          //   document: [
          //     {
          //       title: "",
          //       link: "",
          //       linkDownload:"",
          //       view: false,
          //     },
          //   ],
          // },
        ],
      },
      Module2: {
        title: "Module 2: Calculus, Linear Algegra",
        children: [
          {
            title: "WEEK 1 -- Exercise, Document and Study Guide",
            key: "m2w1",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.1: Seminar AI in Medical",
            key: "m2l1",
            video: "https://www.dropbox.com/scl/fi/gxg7q8oqsgvh3wtr57fn5/M02EC02-Seminar-AI-in-Medical-Zoom.mp4?rlkey=vby2nvl1abhgmksm0endgf4r5&st=a6ij6yj9&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.2: List to Numpy",
            key: "m2l2",
            video: "https://www.dropbox.com/scl/fi/rya56ez6xbzj7hzk9ndra/M02EC03-List-to-Numpy-Zoom.mp4?rlkey=7mf97ekf3qvia5ybfja65hzok&st=a3utrrli&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.3: Programming with high-level syntax (numpy, 1d data)",
            key: "m2l3",
            video: "https://www.dropbox.com/scl/fi/t4x3gahm0qqrsuqmjbws2/M02MC-Programming-with-high-level-syntax-numpy-1d-data-Zoom.mp4?rlkey=mfiutsgyu5e12pj0zrz61vicx&st=7u4h1dxr&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.4: Programming with high-level syntax (numpy, 1d data) (1)",
            key: "m2l4",
            video: "https://www.dropbox.com/scl/fi/z9ulwx56bzuke5m8h9kg1/M02MC-Programming-with-high-level-syntax-numpy-1d-data-Zoom-1.mp4?rlkey=wun900d8clov9hfau2mmmm071&st=zh6libzq&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.5: HCMC AI Competition",
            key: "m2l5",
            video: "https://www.dropbox.com/scl/fi/xgdf8vz9wbe4ei4jm3mb3/M02EC05-HCMC-AI-Competition-Zoom.mp4?rlkey=q67845sgivobbfr3haa5z5sh7&st=o8w166m4&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.6: Programming with high-level syntax (numpy, 2d-3d data)",
            key: "m2l6",
            video: "https://www.dropbox.com/scl/fi/6r6bnv7fcxmjiuqhekcbv/M02MC-Programming-with-high-level-syntax-numpy-2d-3d-data-Zoom.mp4?rlkey=3dm01p8fbvyypt89bddz35ioa&st=m59lkcal&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.7: Programming with high-level syntax (numpy, 2d-3d data) (1)",
            key: "m2l7",
            video: "https://www.dropbox.com/scl/fi/gmspq50wpc9pby6b2f0zk/M02MC-Programming-with-high-level-syntax-numpy-2d-3d-data-Zoom-1.mp4?rlkey=wim3itaamme8a9hqt670ovcn8&st=icokl4rw&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.8: Data - SQL 1",
            key: "m2l8",
            video: "https://www.dropbox.com/scl/fi/7ttlqhjbedgbi241ehnlz/M02EC07-Data-SQL-1-Zoom.mp4?rlkey=01ui7b7gur484ela8dspwlrlt&st=1ns4p72g&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.9: TA-Exercise",
            key: "m2l9",
            video: "https://www.dropbox.com/scl/fi/cyjm253wi9ahgdhh436fa/M02MC-TA-Exercise-Zoom.mp4?rlkey=fgcpdtgtulcbpn8prp6r57btv&st=xi7vyhff&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 2 -- Exercise, Document and Study Guide",
            key: "m2w2",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.10: Seminar Self-Supervised Learning",
            key: "m2l10",
            video: "https://www.dropbox.com/scl/fi/an7lggehwug26qrqk317t/M02EC02-Seminar-Delving-into-Semi-Supervised-Medical-Segmentation-Zoom.mp4?rlkey=dpwxqrhekdj7sapwisfbxebcz&st=gtovjobi&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.11: Numpy",
            key: "m2l11",
            video: "https://www.dropbox.com/scl/fi/zslmp3m7utsclk3xh2onr/M02MC-Numpy-Zoom.mp4?rlkey=cnzzzdtehjjlavfkuymz2z6pj&st=gqfe051n&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.12: Vector and Matrix",
            key: "m2l12",
            video: "https://www.dropbox.com/scl/fi/mlg97bdljswv49z16mnvj/M02MC-Vector-and-Matrix-Zoom.mp4?rlkey=z6cx1so3repnp5icjsna3vap3&st=3v4si7lx&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.13: Design Validation",
            key: "m2l13",
            video: "https://www.dropbox.com/scl/fi/s5q52j6kzeri5k9zok33y/M02EC05-Lesson-4-Design-Validation-Zoom.mp4?rlkey=4ilan2u29b6i1khl2aobeyifz&st=hcrrpfuo&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.14: Cosine similarity and Data Similarity",
            key: "m2l14",
            video: "https://www.dropbox.com/scl/fi/7i52rsafzqegej5q0fumy/M02MC-Cosine-similarity-and-Data-Similarity-Zoom.mp4?rlkey=vzcty515q577jdwsbo2tqw39v&st=2l68ywpr&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.15: Cosine similarity and Data Similarity (1)",
            key: "m2l15",
            video: "https://www.dropbox.com/scl/fi/0v2ynq9cx4fvg705g3dad/M02MC-Cosine-similarity-and-Data-Similarity-Zoom-1.mp4?rlkey=i9t0jwz8tah21xgkq1z9d3h2a&st=e6pswcr1&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.16: Data - SQL 2",
            key: "m2l16",
            video: "https://www.dropbox.com/scl/fi/mtt3tiqv7l7w9tpax84ih/M02EC07-Data-SQL-2-Zoom.mp4?rlkey=9gfhil7b270t9tuhurbkxs7bk&st=dcm4fzn5&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.17: TA-Exercise",
            key: "m2l17",
            video: "https://www.dropbox.com/scl/fi/2u2nryirpyk466pwheef3/M02MC-EXERCISE-Zoom.mp4?rlkey=mmw6w9xqp7phb2olmdocdst41&st=7843bgq8&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 3 -- Exercise, Document and Study Guide",
            key: "m2w3",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.18: Seminar: DG Seminar",
            key: "m2l18",
            video: "https://www.dropbox.com/scl/fi/j924f4eruw0b9rgb2zwki/M02EC-Seminar-DG-Seminar-Zoom.mp4?rlkey=qfvsxx7rjbfds109fbiasolxb&st=s6imdper&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.19: Basic Probability",
            key: "m2l19",
            video: "https://www.dropbox.com/scl/fi/s4u2jr1b8779kjcwu7244/M02EC03-Basic-Probability-Zoom.mp4?rlkey=i1r3e8r950mk309t2jgxh11q3&st=dvjgx4h3&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.20: Basic Probability and AI",
            key: "m2l20",
            video: "https://www.dropbox.com/scl/fi/zcxsksvbb506wqhhdbu7z/M02MC-Basic-Probability-and-AI-Zoom.mp4?rlkey=9ntx6qyi169dgiceah1d9xz6o&st=imd431uj&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.21: Basic Probability and AI (1)",
            key: "m2l21",
            video: "https://www.dropbox.com/scl/fi/p2syn3wv00sa7qvzdj8yd/M02MC-Basic-Probability-and-AI-Zoom-1.mp4?rlkey=nc57mx4c71e8qa7dr3qxj7jbh&st=k7o0dz2l&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.22: Ensemble Learning - Competition 2",
            key: "m2l22",
            video: "https://www.dropbox.com/scl/fi/cg73sbt6swzob59140xnu/M02EC05-Lesson-5-Ensemble-Learning-Competition-2-Zoom.mp4?rlkey=nap984nenhvk2o0992790egae&st=srku1vwf&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.23: Naïve Bayes classifier (Classification) (slide - version 4)",
            key: "m2l23",
            video: "https://www.dropbox.com/scl/fi/0e55ix5bdy0kg8jxuqmz7/M02MC-Na-ve-Bayes-classifier-Classification-1-Zoom.mp4?rlkey=ufk39s6beg4ul0b13y8t7ifwu&st=fy2b1tm5&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.24: Naïve Bayes classifier (Classification) (slide - version 4) (1)",
            key: "m2l24",
            video: "https://www.dropbox.com/scl/fi/azwntxk98vmzffo2u1gv9/M02MC-Na-ve-Bayes-classifier-Classification-2-Zoom.mp4?rlkey=au661dzmytl2nre4sqrkhfbra&st=mucxafez&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.25: Data - SQL 3",
            key: "m2l25",
            video: "https://www.dropbox.com/scl/fi/kygvvdyo47vh1amrn7crl/M02EC07-Data-SQL-3-Zoom.mp4?rlkey=42a0ushojksxn9fg3v18vy2rn&st=jn45j5ju&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.26: TA-Exercise",
            key: "m2l26",
            video: "https://www.dropbox.com/scl/fi/87h1gp0ougnm9sbsw7x6n/M02MC-TA-Exercise-2-Zoom.mp4?rlkey=1jib9hd128ushsjkfnc9s17hk&st=ytyxmfyw&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 4 -- Exercise, Document and Study Guide",
            key: "m2w4",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.27: Exploring Disease Classification Methods for Volumetric (3D) Medical Image (CTs/MRIs)",
            key: "m2l27",
            video: "https://www.dropbox.com/scl/fi/8q0mczd3vsvbojqpfaq1i/M02EC02-SEMINAR-Zoom.mp4?rlkey=2340upr71tchms70hm01z5orw&st=0ysls88j&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.28: Basic Statistics",
            key: "m2l28",
            video: "https://www.dropbox.com/scl/fi/1qhxfwpt6x40uz3y0oeix/M02EC03-Basic-Statistics1-Zoom.mp4?rlkey=6rsm8owi0ra6b9nf6jy69ooc3&st=f9kzaz9f&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.29: Basic Statistics (1)",
            key: "m2l29",
            video: "https://www.dropbox.com/scl/fi/sx27vkgeq74vboybt1591/M02EC03-Basic-Statistics2-Zoom.mp4?rlkey=qjdx6duc9dtblkcqkayqaaurl&st=6k3up9ee&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.30: Basic Statistics and Correlation Coefficient (Basic Tracking)",
            key: "m2l30",
            video: "https://www.dropbox.com/scl/fi/cyyjqc46d9v4tz5uul7yu/M02MC-Basic-Statistics-and-Correlation-Coefficient-Basic-Tracking-Zoom.mp4?rlkey=llp5vjilmbtgei5rs2xjksdkw&st=2l39w2nz&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.31: Seminar Alumni",
            key: "m2l31",
            video: "https://www.dropbox.com/scl/fi/2rryyd5mljpkzpmuviy9d/M02EC05-SEMINAR-Zoom.mp4?rlkey=2v310nded0i97c4bse8extlnx&st=f3heq9iy&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.32: Statistics and AI",
            key: "m2l32",
            video: "https://www.dropbox.com/scl/fi/55dbmjv3j7f098eux0gy9/M02MC-Statistics-and-AI-Zoom.mp4?rlkey=6z72qqt0sffawmnx9ldfitl8w&st=dzns4lzl&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.33: SQL - for Big Data",
            key: "m2l33",
            video: "https://www.dropbox.com/scl/fi/hujc27n1sq9frnvzg2may/M02EC07-SQL-for-Big-Data-Zoom.mp4?rlkey=bdsgb5zglz9khvt7cnu3h5ifp&st=l1a6mvqf&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.34: TA-Exercise (slide v2)",
            key: "m2l34",
            video: "https://www.dropbox.com/scl/fi/8kv31614ngy4k2typka2h/M02MC-482024-TA-Exercise-Zoom.mp4?rlkey=kp4yumd9y3f2t2ul3mvwp6i3r&st=p4k1fm63&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 5 -- Exercise, Document and Study Guide",
            key: "m2w5",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.35: Text Classification",
            key: "m2l35",
            video: "https://www.dropbox.com/scl/fi/isecfwmm6rs1dba9yop56/M02MC-Text-Classification1-Zoom.mp4?rlkey=a98javmt1pjaqjvto89gjocj4&st=1zfn58xz&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.36: Text Classification (1)",
            key: "m2l36",
            video: "https://www.dropbox.com/scl/fi/uncobkxp5afqt4xgoz4go/M02MC-Text-Classification2-Zoom.mp4?rlkey=zst7vtsg1ypoqgn2gvz4y3ony&st=uig5z2w2&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.37: Text Classification (2)",
            key: "m2l37",
            video: "https://www.dropbox.com/scl/fi/rdd0lr7ghp8psoja5chg0/M02MC-Text-Classification3-Zoom.mp4?rlkey=xpbicgklj3i5eujffne97yj28&st=xr9w13xc&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.38: Text/image Retrieval",
            key: "m2l38",
            video: "https://www.dropbox.com/scl/fi/9k30zt8neckb4wxbchuus/M02MC-Text-image-Retrieval-Zoom.mp4?rlkey=7fjx5068u3e50uk3irzuaw3c0&st=ww1k4w8n&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 2.39: Image Project: Depth Information Estimation",
            key: "m2l39",
            video: "https://www.dropbox.com/scl/fi/yoeuy4k527rtulsz4cpek/M02MC-Image-Project-Depth-Information-Estimation-Zoom.mp4?rlkey=vj0uusqfw64of4bwaiajzi0mv&st=ocdy9f55&raw=1",
            document: [
              
            ],
          },
        ],
      },
      Module3: {
        title: "Module 3: Prob Statistics Optim",
        children: [
          {
            title: "WEEK 1 -- Exercise, Document and Study Guide",
            key: "m3w1",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.1: Pandas",
            key: "m3l1",
            video: "https://www.dropbox.com/scl/fi/c5ymeyqgblqiom10p35nx/M03MC-Pandas-Zoom.mp4?rlkey=pzh1b76nyohn6uj0lrh5ojccl&st=88udnmub&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.2: Data Visualization and Analysis (1)",
            key: "m3l2",
            video: "https://www.dropbox.com/scl/fi/c46c5zr4mkv9b8hg1elkv/M03MC_Data-Visualization-and-Analysis-1-Zoom.mp4?rlkey=yhrf22gmyae5cd4ll1erkmd6r&st=1xmci32g&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.3: Data Visualization and Analysis (1)-2",
            key: "m3l3",
            video: "https://www.dropbox.com/scl/fi/5oss4ljfohzfoko3juoep/M03MC_Data-Visualization-and-Analysis-1-Zoom.mp4?rlkey=wz9ikes3s7b4nzgdfyric4926&st=k6egxxo7&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.4: Time-series Data in Medical",
            key: "m3l4",
            video: "https://www.dropbox.com/scl/fi/gj03gnr9yl3hoen8chdhi/M03EC05-Time-series-Data-in-Medical-Zoom.mp4?rlkey=avdhyjvk73pldm5jr3fq1bire&st=hr0722yx&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.5: Data Visualization and Analysis (2)",
            key: "m3l5",
            video: "https://www.dropbox.com/scl/fi/s1s033kq6gt5oo855jdvl/M03MC-Data-Visualization-and-Analysis-2-Zoom.mp4?rlkey=rg0w03w2s1h58n873eg05suic&st=axf85911&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.6: Data Visualization and Analysis (2)-1",
            key: "m3l6",
            video: "https://www.dropbox.com/scl/fi/5oss4ljfohzfoko3juoep/M03MC_Data-Visualization-and-Analysis-1-Zoom.mp4?rlkey=wz9ikes3s7b4nzgdfyric4926&st=bbnej1sy&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.7: Talk with the Research Lecturer (nhóm research)",
            key: "m3l7",
            video: "https://www.dropbox.com/scl/fi/76yj6wfckoa3macpdd1h2/M03EC07-Research-Talk-with-the-Research-Lecturer-nh-m-research-Zoom.mp4?rlkey=67flgfmkqfmk7jp0hmwr3wxqp&st=mgmr69p2&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.8: TA-Exercise",
            key: "m3l8",
            video: "https://www.dropbox.com/scl/fi/4zo7cguqn9ppdx05atzdh/M03MC-TA-Exercise-Zoom.mp4?rlkey=svckresn9e0246wx59zaxmegm&st=x15nstlc&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 2 -- Exercise, Document and Study Guide",
            key: "m3w2",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.9: K Nearest Neighbor (KNN)",
            key: "m3l9",
            video: "https://www.dropbox.com/scl/fi/3j7pk6m5u0mj7h4mdnz7l/M03MC-K-Nearest-Neighbor-KNN-Zoom.mp4?rlkey=c27s6prtk8w2ijcs0t7p8s8l5&st=u0fqmh5t&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.10: K Nearest Neighbor (KNN) (Main)",
            key: "m3l10",
            video: "https://www.dropbox.com/scl/fi/i1rxogge3ph8dydy4o675/M03EC03-K-Nearest-Neighbor-KNN-1-Zoom.mp4?rlkey=jlndiaeoz1fleao1nl1o6mzs9&st=lnt7g9b6&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.11: K Nearest Neighbor (KNN) (Main) (1)",
            key: "m3l11",
            video: "https://www.dropbox.com/scl/fi/iq3lpmkecuk0ouimtttnk/M03EC03-K-Nearest-Neighbor-KNN-1-Zoom.mp4?rlkey=80vautekl8ubwrjmhqe6sx6di&st=eklu6ayq&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.12: Tổng quan công việc của một DS",
            key: "m3l12",
            video: "https://www.dropbox.com/scl/fi/pbm93qv0z9swnsf7yk096/M03EC05-T-ng-quan-c-ng-vi-c-c-a-m-t-DS-1-Zoom.mp4?rlkey=na4e4ceo0xgn3md97qg9ufhf1&st=y5l6a9zc&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.13: Tổng quan công việc của một DS (1)",
            key: "m3l13",
            video: "https://www.dropbox.com/scl/fi/5oqfcf5psetfeh74fhusi/M03EC05-T-ng-quan-c-ng-vi-c-c-a-m-t-DS-1-Zoom.mp4?rlkey=l8i13tphcxl3ueoly7bjl0jl5&st=tj50tk3k&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.14: K-Means",
            key: "m3l14",
            video: "https://www.dropbox.com/scl/fi/cv80u151oqo3hispnuew4/240830-M03MC-K-Means-1-Zoom.mp4?rlkey=d4pizbbycwxa6374wt7fieqh4&st=gk5zjgww&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.15: K-Means (1)",
            key: "m3l15",
            video: "https://www.dropbox.com/scl/fi/hn3ysursa0nutkaxk5n6e/240830-M03MC-K-Means-1-Zoom.mp4?rlkey=prmulr63rdc6zmlh2l6352424&st=3jres1l7&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.16: Advanced Data Visualization",
            key: "m3l16",
            video: "https://www.dropbox.com/scl/fi/2e2yufz85467c19aybcsw/240831-M03EC07-Advanced-Data-Visualization-Zoom.mp4?rlkey=luwygobwzynh3emlzjhm3co1v&st=veiijg0o&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.17: TA-Exercise",
            key: "m3l17",
            video: "https://www.dropbox.com/scl/fi/f1f3uyvx1xr4er7lqo7fb/240901-M03MC_TA-Exercise-Zoom.mp4?rlkey=u2l2vzy6nd9auj0aabjg3hqdg&st=h69ay9o6&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 3 -- Exercise, Document and Study Guide",
            key: "m3w3",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.18: Decision Tree",
            key: "m3l18",
            video: "https://www.dropbox.com/scl/fi/mo71f920nid3u4qwy61zt/240903-M03EC03-Decision-Tree-Zoom.mp4?rlkey=8mgvzr59m6ktt57oj9zzvy1vk&st=ujvpdbn5&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.19: Decision Tree for Classification",
            key: "m3l19",
            video: "https://www.dropbox.com/scl/fi/5aolq3przz1x42qe4r0s9/240904-M03MC-Decision-Tree-for-Classification-Zoom.mp4?rlkey=81x4p1ufh7ne1dqc3s8ahiwnj&st=88nrxcj6&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.20: Decision Tree for Regression",
            key: "m3l20",
            video: "https://www.dropbox.com/scl/fi/uuzg2jdtq9h1n9t7fdyny/240906-M03MC-Decision-Tree-for-Regression-Zoom.mp4?rlkey=v2llhzanwb0yhubss8ct0f51j&st=6fukhzuk&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.21: PySpark for Data Processing",
            key: "m3l21",
            video: "https://www.dropbox.com/scl/fi/sapyxyq4fpoqrenbm6agd/240907-M03EC-PySpark-for-Data-Processing-Zoom.mp4?rlkey=8wfbhkrpkhzp2zluae295kr01&st=rchv8op9&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.22: TA-Exercise",
            key: "m3l22",
            video: "https://www.dropbox.com/scl/fi/wev40xfi8oea8rxxwmold/240908-M03MC-TA-Exercise-Zoom.mp4?rlkey=qpt5fvg7hffbak5cwbyjnhrbb&st=uy4qlrln&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 4 -- Exercise, Document and Study Guide",
            key: "m3w4",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.23: Random Forest",
            key: "m3l23",
            video: "https://www.dropbox.com/scl/fi/46iqandnl65f9wacbjjjh/240910-Random-Forest-Zoom.mp4?rlkey=7mu5nn7y2345f1fe1793jptq4&st=3jvgjg5f&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.24: Random Forest (main)",
            key: "m3l24",
            video: "https://www.dropbox.com/scl/fi/fbhvr7qolz207861qobw7/240911-M03MC-Random-Forest-Zoom.mp4?rlkey=xhwxdxm1s6chc66vzr6h0fqjz&st=q3c1k5te&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.25: AI in Robotics",
            key: "m3l25",
            video: "https://www.dropbox.com/scl/fi/vhvopogzzfslb24xdfjrp/240912-M03EC05-Seminar-AI-in-Robotics-Zoom.mp4?rlkey=7y8vvxwtmqwbo84my5pv9muyn&st=6ltt42md&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.26: AdaBoost & Gradient Boost",
            key: "m3l26",
            video: "https://www.dropbox.com/scl/fi/8266oq2htt7lq52tm9dyu/240913-M03MC-AdaBoost-Gradient-Boost-Zoom.mp4?rlkey=vee335vbdojf88zytvbdwxoa8&st=rdy38sha&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.27: SVM",
            key: "m3l27",
            video: "https://www.dropbox.com/scl/fi/rtg3c0f7v1chr4zi7zwyo/240914-M03MC07-SVM-Zoom.mp4?rlkey=8otb8tv08gvwswf7vurv14k85&st=al46swdw&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.28: TA-Exercise",
            key: "m3l28",
            video: "https://www.dropbox.com/scl/fi/s75qybehol43k19iosto7/240915-MC03-TA-Exercise-Zoom.mp4?rlkey=nmfq3r9vqbv6hprxvkk4wgl3z&st=c623ohdk&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 5 -- Exercise, Document and Study Guide",
            key: "m3w5",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.29: XGBoost",
            key: "m3l29",
            video: "https://www.dropbox.com/scl/fi/opavz3cnadnj55u1z9fl4/240918-MC03W05-_-XGBoost-Zoom.mp4?rlkey=wpsgi4002sgssb4bvxja02y0b&st=3cqx5r9k&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.30: XGBoost for Time-series and Tabular data",
            key: "m3l30",
            video: "https://www.dropbox.com/scl/fi/6491n36vowelyncjljylk/240920-M03MC-XGBoost-for-Time-series-and-Tabular-data-Zoom.mp4?rlkey=u81leesqs3024zcma4m7zm9bv&st=eb7riy2z&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.31: Text Project: Đánh giá mức độ hài lòng của khách hàng",
            key: "m3l31",
            video: "https://www.dropbox.com/scl/fi/9xsrxlwa3kg9mw1omcgcz/240922-M03MC-Text-Project-nh-gi-m-c-h-i-l-ng-c-a-kh-ch-h-ng-Zoom.mp4?rlkey=clcan1u0dfaxv5k54ob8qqry5&st=awf23n8y&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 3.32: Tabular Data & Tree-based Project: Heart Disease Prediction",
            key: "m3l32",
            video: "https://www.dropbox.com/scl/fi/mre5ixcni92dipmvs7f21/240925-M03MC-Tabular-Data-Tree-based-Project-Heart-Disease-Prediction-Zoom.mp4?rlkey=ezut3wflxx5b1tkyal33xcy3n&st=g4cixkdr&raw=1",
            document: [
              
            ],
          },    
        ],
      },
      // Module 4: Machine Learning and Data Science
      Module4: {
        title: "Module 4: Machine Learning, DS",
        children: [
          {
            title: "WEEK 1 -- Exercise, Document and Study Guide",
            key: "m4w1",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.1: (Research Group) Talk with Teacher",
            key: "m4l1",
            video: "https://www.dropbox.com/scl/fi/f621n8ny8oyuggrmwd87f/240930-M04EC02_-Research-Group-Talk-with-Teacher-Zoom.mp4?rlkey=aw5t8q4e6ejtvfr69iknxrut3&st=h5j7gxqc&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.2: Basic Linear Regression",
            key: "m4l2",
            video: "https://www.dropbox.com/scl/fi/s757996s2xkntf1uer9ii/241001-M04EC03_Basic-Linear-Regression-Zoom.mp4?rlkey=r7rnhjhr8vyc0trunjyrvsous&st=cz3cys26&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.3: From Optimization to Linear Regression",
            key: "m4l3",
            video: "https://www.dropbox.com/scl/fi/3x9n160izub2xhpndu08m/241002-M04MC-From-Optimization-to-Linear-Regression-Zoom.mp4?rlkey=ussaiv88ko2pvvewb4kwkue75&st=syjbfy7a&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.4: How to become Grandmaster in Kaggle",
            key: "m4l4",
            video: "https://www.dropbox.com/scl/fi/kpit0q0djzcfof9yrrmz1/241003-M04EC05_How-to-become-Grandmaster-in-Kaggle-Zoom.mp4?rlkey=359qpzthw7eh2ezrd38ndttil&st=l24uwmg0&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.5: Linear Regression (mini-batch training)",
            key: "m4l5",
            video: "https://www.dropbox.com/scl/fi/lsmmmne8q2e6zvxzyo3v8/241004-M04MC-Linear-Regression-mini-batch-training-Zoom.mp4?rlkey=ycgzjkw25fgsmaeaam6rmexyb&st=ccbqih6b&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.6: Streamlit and Gradio",
            key: "m4l6",
            video: "https://www.dropbox.com/scl/fi/7vylpu7p4q4soql3wjk35/241005-M04EC07_Streamlit-and-Gradio-Zoom.mp4?rlkey=0ajdgir2x2k8caua76kg7001s&st=obu499ss&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.7: TA-Exercise",
            key: "m4l7",
            video: "https://www.dropbox.com/scl/fi/fih3gk4yoon42za49gdop/241006-M04MC-TA-Exercise-Zoom.mp4?rlkey=60zized38rtv82yv58ndsg613&st=js55snfl&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 2 -- Exercise, Document and Study Guide",
            key: "m4w2",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.8: Linear Regression Using Numpy",
            key: "m4l8",
            video: "https://www.dropbox.com/scl/fi/5atdzdkmf2zmv73ibz367/M04EC03-Linear-Regression-Using-Numpy-Zoom.mp4?rlkey=d0wvj5xvfwqc9pfl9q4upqni0&st=2khjd4rr&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.9: Vectorization for Linear Regression (1)",
            key: "m4l9",
            video: "https://www.dropbox.com/scl/fi/okmene752xaox3yv2jggf/M04MC-Vectorization-for-Linear-Regression-1-Zoom.mp4?rlkey=5i4fgysdkcdlgejm84z3gzllb&st=bwy5gt1t&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.10: Web Deployment Using FastAPI and Gradio",
            key: "m4l10",
            video: "https://www.dropbox.com/scl/fi/oqb43je9gl8ge6j0qpox5/M04EC-Web-Deployment-Using-FastAPI-and-Gradio-Zoom.mp4?rlkey=mczcvnijn1xr8n7oh35zv0lxd&st=en4ljfhc&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.11: Web Deployment Using FastAPI and Gradio (1)",
            key: "m4l11",
            video: "https://www.dropbox.com/scl/fi/1zc20as194cxy4sz9sgb4/M04EC-Web-Deployment-Using-FastAPI-and-Gradio-Zoom-1.mp4?rlkey=6frxq3226hdlu7ygv4tq7t55p&st=aeonjzxi&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.12: Vectorization for Linear Regression (2)",
            key: "m4l12",
            video: "https://www.dropbox.com/scl/fi/idymtjj9c6l8clj5zlni7/M04MC-Vectorization-for-Linear-Regression-2-Zoom.mp4?rlkey=d863vuv9bmwk7fn9pr58vwo8x&st=0k6d5l6g&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.13: Vectorization for Linear Regression (2) (1)",
            key: "m4l13",
            video: "https://www.dropbox.com/scl/fi/zrz6ob3t8zmzoekjgaid8/M04MC-Vectorization-for-Linear-Regression-2-Zoom-1.mp4?rlkey=ibf92jlm48ix1ysdax1y303ha&st=se2bv6c4&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.14: Non-linear Regression",
            key: "m4l14",
            video: "https://www.dropbox.com/scl/fi/a01213gy36zh91zycnkg7/AI-VIET-NAM_s-Zoom-Meeting-Zoom.mp4?rlkey=b2msczpg7do6pp45yel6u349b&st=56jotci3&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.15: TA-Exercise",
            key: "m4l15",
            video: "https://www.dropbox.com/scl/fi/w1ckuyxf28i1z6p97jmzq/M04MC-TA-Exercise-Zoom.mp4?rlkey=xeajnbqoi3m6sb4t2wbz3ibz9&st=a94s6ixy&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 3 -- Exercise, Document and Study Guide",
            key: "m4w3",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.16: Basic Genetic Algorithms",
            key: "m4l16",
            video: "https://www.dropbox.com/scl/fi/7fyz43vmlevbdhgd7sjml/M04EC03-Basic-Genetic-Algorithms-Zoom.mp4?rlkey=pju6iooqecp3qkgt7k748jcin&st=xdhu1eur&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.17: Randomness and Genetic Algorithms",
            key: "m4l17",
            video: "https://www.dropbox.com/scl/fi/0i3lbhqzpeoucy5z9xth3/M04MC-Randomness-and-Genetic-Algorithms-Zoom.mp4?rlkey=473rs57ki4tto1k0ugyf88mgm&st=qathimv7&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.18: Dockerize FastAPI and Gradio",
            key: "m4l18",
            video: "https://www.dropbox.com/scl/fi/za3s87b5no554h38gaoc8/M04EC05-Dockerize-FastAPI-and-Gradio-Zoom.mp4?rlkey=t7l842xuvlhtqwdguxmfled41&st=l3yn9bz4&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.19: Genetic Algorithms (Optimization and Linear regression)",
            key: "m4l19",
            video: "https://www.dropbox.com/scl/fi/rl856kg4lrkd2bwo4ibks/M04MC-Genetic-Algorithms-Optimization-and-Linear-regression-Zoom.mp4?rlkey=0pirxj7a6hgu0xdfwkyvyb5gk&st=bl71iyg1&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.20: Loss Functions for Regression",
            key: "m4l20",
            video: "https://www.dropbox.com/scl/fi/0p0x7ky0f2plub6tz9p1t/M04EC07-Loss-Functions-for-Regression-Zoom.mp4?rlkey=5hy8yw2zpiai2729fqdupcwza&st=mywv53bb&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.21: TA-Exercise",
            key: "m4l21",
            video: "https://www.dropbox.com/scl/fi/sm0r1wa1zrgzwz8cf3mz3/M04MC-TA-Exercise-Zoom.mp4?rlkey=w7u6hkvkcoiig9bjab1vyj6lc&st=sag4h0nu&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 4 -- Exercise, Document and Study Guide",
            key: "m4w4",
            video: " ",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.22: Tabular Data Project: Sales Prediction (Linear and non-linear Regressions)",
            key: "m4l22",
            video: "https://www.dropbox.com/scl/fi/yzje53d5l9g3c347j86wr/M04MC-Tabular-Data-Project-Sales-Prediction-Linear-and-non-linear-Regressions-Zoom.mp4?rlkey=kc68vfh6ih74jv0r9306s6nhj&st=j63qmjy3&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.23: Buổi hướng dẫn cho cuộc thi BKAI",
            key: "m4l23",
            video: "https://www.dropbox.com/scl/fi/js7dtjprvfu0cnc51de93/M04EC-Bu-i-h-ng-d-n-cho-cu-c-thi-BKAI-Zoom.mp4?rlkey=fv3uqd6vy276ecnyk203tiqip&st=yrlb49p8&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.24: Project: Multi-objective Evolutionary Algorithm ",
            key: "m4l24",
            video: "https://www.dropbox.com/scl/fi/39spmpqgsshnlein1ji26/Project-Multi-objective-Evolutionary-Algorithm-Zoom.mp4?rlkey=vh7bmmzdure4xec6vrns5bv45&st=ijkf2uhq&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.25: Cloud cho triển triên các mô hình ML",
            key: "m4l25",
            video: "https://www.dropbox.com/scl/fi/lih79d48bhw4xoc74vtnd/M04EC07-Cloud-cho-tri-n-tri-n-c-c-m-h-nh-ML-Zoom.mp4?rlkey=qd7i1sto44yzp37n6fd793v7f&st=bedpuces&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.26: Cloud cho triển triên các mô hình ML (1)",
            key: "m4l26",
            video: "https://www.dropbox.com/scl/fi/sv1ekck98al4cm8kxzds4/M04EC07-Cloud-cho-tri-n-tri-n-c-c-m-h-nh-ML-Zoom_-1.mp4?rlkey=0cxj6byxxu2m1o5s06xnea2em&st=k5wdj3jg&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 4.27: Seminar: Accepted Paper from AIO",
            key: "m4l27",
            video: "https://www.dropbox.com/scl/fi/nryq0o3or8u5860l70jqe/M04MC-Seminar-Accepted-Paper-from-AIO-Zoom.mp4?rlkey=d2b3nhebei5z2znl39yymor97&st=810r2ugg&raw=1",
            document: [
              
            ],
          },
        ],
      },
      Module5: {
        title: "Module 5: Steps to Deep Learning",
        children: [
          // week1
          {
            title: "WEEK 1 -- Exercise, Document and Study Guide",
            key: "V0",
            video: " ",
            document: [
              {
                title: "M05W01 - Study Guide.pdf",
                link: "https://www.dropbox.com/scl/fi/b4aeo0fqic7tqm8lxs0nu/M05W01-Study-Guide.pdf?rlkey=kl1wqxidvwvztf980ud6homr0&st=ty9dy5hz&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/b4aeo0fqic7tqm8lxs0nu/M05W01-Study-Guide.pdf?rlkey=kl1wqxidvwvztf980ud6homr0&st=6wb58v60&dl=1",
                view: true,
              },
              {
                title:
                  "M05W01 - AIO2024_Module05_Exercise_Logistic_Regression_Description_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/a8ivpe11hbiviqft97tbr/AIO2024_Module05_Exercise_Logistic_Regression_Description_v2.pdf?rlkey=fvxnsiku4x75r1vj2qajfhb10&st=8ei9utny&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/a8ivpe11hbiviqft97tbr/AIO2024_Module05_Exercise_Logistic_Regression_Description_v2.pdf?rlkey=fvxnsiku4x75r1vj2qajfhb10&st=8ei9utny&dl=1",
                view: true,
              },
              {
                title:
                  "M05W01 - AIO2024_Module05_Exercise_Logistic_Regression_Rubric.pdf",
                link: "https://www.dropbox.com/scl/fi/pq5cgwjgxce3hm30vlncc/AIO2024_Module05_Exercise_Logistic_Regression_Rubric.pdf?rlkey=u039gi2dvphvxvc39cemn5jzb&st=1oe4wgi6&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/pq5cgwjgxce3hm30vlncc/AIO2024_Module05_Exercise_Logistic_Regression_Rubric.pdf?rlkey=u039gi2dvphvxvc39cemn5jzb&st=1oe4wgi6&dl=1",
                view: true,
              },
              {
                title:
                  "M05W01 - Reading - Speedup Model Inferencing with Numba and TorchJIT.pdf",
                link: "https://www.dropbox.com/scl/fi/um5l5kamcvoj677n2xb5y/M05W01-Reading-Speedup-Model-Inferencing-with-Numba-and-TorchJIT.pdf?rlkey=4ihil5se5d89bjgdqhx3vw9lo&st=cq87axqo&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/um5l5kamcvoj677n2xb5y/M05W01-Reading-Speedup-Model-Inferencing-with-Numba-and-TorchJIT.pdf?rlkey=4ihil5se5d89bjgdqhx3vw9lo&st=cq87axqo&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.1: Basic Logicstic Regression",
            key: "V1",
            video:
              "https://www.dropbox.com/scl/fi/2kdnb9g18ytay7rui0jz2/M05EC03-Basic-Logicstic-Regression-Zoom.mp4?rlkey=uz6spe56b5ept6o8orrfzf56b&st=9ez5eepu&raw=1",
            document: [
              {
                title: "[Slide-V3]-Logistic-Regression.pdf",
                link: "https://www.dropbox.com/scl/fi/245p7xa63hnykyyr13bpe/Slide-V3-Logistic-Regression.pdf?rlkey=9uqox6ldw8qs8rd99m0xkru5v&st=sy9ibs06&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/245p7xa63hnykyyr13bpe/Slide-V3-Logistic-Regression.pdf?rlkey=9uqox6ldw8qs8rd99m0xkru5v&st=sy9ibs06&dl=1",
                view: true,
              },
              {
                title:
                  "AIO2024_Module05_Exercise_Logistic_Regression_Description_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/vz5z3uso7illof5at5615/AIO2024_Module05_Exercise_Logistic_Regression_Description_v2.pdf?rlkey=mcjgs9eblfhgzvyfnbv1fr62r&st=py5hvl9s&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/vz5z3uso7illof5at5615/AIO2024_Module05_Exercise_Logistic_Regression_Description_v2.pdf?rlkey=mcjgs9eblfhgzvyfnbv1fr62r&st=py5hvl9s&dl=1",
                view: true,
              },
              {
                title:
                  "AIO2024_Module05_Exercise_Logistic_Regression_Rubric.pdf",
                link: "https://www.dropbox.com/scl/fi/rkmvyntkk7f3cxyfibg7j/AIO2024_Module05_Exercise_Logistic_Regression_Rubric.pdf?rlkey=m7mpv3jq79hff29lsfpykyeeg&st=b4r49n2v&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/rkmvyntkk7f3cxyfibg7j/AIO2024_Module05_Exercise_Logistic_Regression_Rubric.pdf?rlkey=m7mpv3jq79hff29lsfpykyeeg&st=b4r49n2v&dl=1",
                view: true,
              },
            ],
          },
          {
            title:
              "Lesson 5.2: From Linear Regressiong to Logistic Regression (Binary Classification)",
            key: "V2",
            video:
              "https://www.dropbox.com/scl/fi/m8eicwy45at94seeevw0m/M05MC-From-Linear-Regressiong-to-Logistic-Regression-Binary-Classification-Zoom.mp4?rlkey=lbc2rc9xql6etreeea8mv9n52&st=dcax5jmy&raw=1",
            document: [
              {
                title: "From Linear Regression to Logistic Regression_v5.pdf",
                link: "https://www.dropbox.com/scl/fi/yzus4985bqlrefvfmvlco/From-Linear-Regression-to-Logistic-Regression_v5.pdf?rlkey=3b1uoedsxfuk4j22r6mtvorf9&st=x64yx4to&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/yzus4985bqlrefvfmvlco/From-Linear-Regression-to-Logistic-Regression_v5.pdf?rlkey=3b1uoedsxfuk4j22r6mtvorf9&st=x64yx4to&dl=1",
                view: true,
              },
            ],
          },
          {
            title:
              "Lesson 5.3: Speed up Model Inferencing Using Numba+TorchScript",
            key: "V3",
            video:
              "https://www.dropbox.com/scl/fi/tdqj3o8fq0kaxod6czv75/M05EC05-Speed-up-Model-Inferencing-Using-Numba-TorchScript-Zoom.mp4?rlkey=kzad5td5ho3y1srnroicfd9jo&st=baytdf4z&raw=1",
            document: [
              {
                title: "Speedup Machine Learning Inference_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/1rtzc8thqpeg1e0tu5s43/Speedup-Machine-Learning-Inference_v2.pdf?rlkey=um6jo2w5gt8f0cewvj58xmyek&st=f27leucf&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/1rtzc8thqpeg1e0tu5s43/Speedup-Machine-Learning-Inference_v2.pdf?rlkey=um6jo2w5gt8f0cewvj58xmyek&st=f27leucf&dl=1",
                view: true,
              },
            ],
          },
          {
            title:
              "Lesson 5.4: Logistic Regression - Vectorization and Application",
            key: "V4",
            video:
              "https://www.dropbox.com/scl/fi/1kkt19g2ndzqtth1j7174/M05MC-Logistic-Regression-Vectorization-and-Application-Zoom.mp4?rlkey=ote2q0qx9ebnmsx5tgihpb2hm&st=haqy7wn7&raw=1",
            document: [
              {
                title: "Advanced Logistic Regression_v3.pdf",
                link: "https://www.dropbox.com/scl/fi/4o4azzfpvghabkyr97izd/Advanced-Logistic-Regression_v3.pdf?rlkey=3pkdad80yqokoo5p6ndxkrsk9&st=dfgmeakd&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/4o4azzfpvghabkyr97izd/Advanced-Logistic-Regression_v3.pdf?rlkey=3pkdad80yqokoo5p6ndxkrsk9&st=dfgmeakd&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.5: Multi-labels Classification",
            key: "V5",
            video:
              "https://www.dropbox.com/scl/fi/ungm0i7sg5vyiy5kwrnu1/M05EC07-Multi-labels-Classification-Zoom.mp4?rlkey=3btxvg7evfwuas6pvp43krkmx&st=4exszr5d&raw=1",
            document: [
              {
                title: "Multi-label classification_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/h4o7wk2gfb65kp52ta7fx/Multi-label-classification_v2.pdf?rlkey=xni6t1hizubivfh4t5v5oiwcg&st=pjkt6h0c&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/h4o7wk2gfb65kp52ta7fx/Multi-label-classification_v2.pdf?rlkey=xni6t1hizubivfh4t5v5oiwcg&st=pjkt6h0c&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.6: TA Exercise week 1",
            key: "V6",
            video:
              "https://www.dropbox.com/scl/fi/0dams39cxf31lypogd6wa/M05MC-TA-Exercise-Zoom-1.mp4?rlkey=xxygzqfr2089e6dddrkfoy550&st=pbkt1v2g&raw=1",
            document: [
              {
                title: "[Slide]-Exercise-LogisticRegression_v3.pdf",
                link: "https://www.dropbox.com/scl/fi/vlc9zd1h3tnfvmo8mjz28/Slide-Exercise-LogisticRegression_v3.pdf?rlkey=7o8yjnywcubqpnpatgxe6bwqh&st=3or7p29m&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/vlc9zd1h3tnfvmo8mjz28/Slide-Exercise-LogisticRegression_v3.pdf?rlkey=7o8yjnywcubqpnpatgxe6bwqh&st=3or7p29m&dl=1",
                view: true,
              },
              {
                title:
                  "AIO2024_Module05_Exercise_Logistic_Regression_Description.pdf",
                link: "https://www.dropbox.com/scl/fi/stg6e5yj4xn8q60ceciv7/AIO2024_Module05_Exercise_Logistic_Regression_Description.pdf?rlkey=si4gm4nraqhzytdkave0whtqd&st=cyjz4f5n&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/stg6e5yj4xn8q60ceciv7/AIO2024_Module05_Exercise_Logistic_Regression_Description.pdf?rlkey=si4gm4nraqhzytdkave0whtqd&st=cyjz4f5n&dl=1",
                view: true,
              },
              {
                title:
                  "AIO2024_Module05_Exercise_Logistic_Regression_Rubric.pdf",
                link: "https://www.dropbox.com/scl/fi/pq5cgwjgxce3hm30vlncc/AIO2024_Module05_Exercise_Logistic_Regression_Rubric.pdf?rlkey=u039gi2dvphvxvc39cemn5jzb&st=ry0wn0my&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/pq5cgwjgxce3hm30vlncc/AIO2024_Module05_Exercise_Logistic_Regression_Rubric.pdf?rlkey=u039gi2dvphvxvc39cemn5jzb&st=ry0wn0my&dl=1",
                view: true,
              },
            ],
          },
          // Week 2
          {
            title: " WEEK 2 -- Exercise, Document and Study Guide",
            key: "W2V",
            video: " ",
            document: [
              {
                title: "M05W02 - Study Guide.pdf",
                link: "https://www.dropbox.com/scl/fi/zjr2hrt0iu3kvcm3z2t57/M05W02-Study-Guide.pdf?rlkey=7pydji7jrw7p003e3di0y6nb2&st=ll15nrcf&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/zjr2hrt0iu3kvcm3z2t57/M05W02-Study-Guide.pdf?rlkey=7pydji7jrw7p003e3di0y6nb2&st=ll15nrcf&dl=1",
                view: true,
              },
              {
                title: "M05W02 - Exercise.pdf",
                link: "https://www.dropbox.com/scl/fi/sc5lcdq2ma6m8r9whmwzy/M05W02-Exercise.pdf?rlkey=sdn5ioe5nn9tdjirhvscgor9m&st=93v6orwe&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/sc5lcdq2ma6m8r9whmwzy/M05W02-Exercise.pdf?rlkey=sdn5ioe5nn9tdjirhvscgor9m&st=93v6orwe&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.7: Basic Softmax Regression",
            key: "V7",
            video:
              "https://www.dropbox.com/scl/fi/phz48bazgn7htejz4bh4w/M05EC03-Basic-Softmax-Regression-Zoom.mp4?rlkey=prvg1q4zcbysc9798wgo1q3s0&st=idl1wphv&raw=1",
            document: [
              {
                title: "[Slide]-Softmax-Regression.pdf",
                link: "https://www.dropbox.com/scl/fi/92tg0y8o043tc62ixolsh/Slide-Softmax-Regression.pdf?rlkey=u35qmuq17hupjcguw2oxdmdnp&st=ds0p30ao&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/92tg0y8o043tc62ixolsh/Slide-Softmax-Regression.pdf?rlkey=u35qmuq17hupjcguw2oxdmdnp&st=ds0p30ao&dl=1",
                view: true,
              },
            ],
          },
          {
            title:
              "Lesson 5.8: Softmax Regression (Multi-class Classification)",
            key: "V8",
            video:
              "https://www.dropbox.com/scl/fi/zler61b6d0i80of4gj8im/M05MC-Softmax-Regression-Multi-class-Classification-Zoom.mp4?rlkey=7xtw41o8qkqfoy79jd1tw1thg&st=rpcsp09e&raw=1",
            document: [
              {
                title: "Softmax Regression_v3.pdf",
                link: "https://www.dropbox.com/scl/fi/s1if8a315upcj0r8qloit/Softmax-Regression_v3.pdf?rlkey=c2niph2zm2dwpbnoxo05qy4mt&st=hiwwxozn&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/s1if8a315upcj0r8qloit/Softmax-Regression_v3.pdf?rlkey=c2niph2zm2dwpbnoxo05qy4mt&st=hiwwxozn&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.9: Model Serving and Packaging",
            key: "V9",
            video:
              "https://www.dropbox.com/scl/fi/tz5rfym0q9zpnmj3po1wv/M05EC05-Model-Serving-and-Packaging-Zoom.mp4?rlkey=wlalvyefcfdva53p7cmn57y77&st=hrv6ocoz&raw=1",
            document: [
              {
                title:
                  "Introduction to Machine Learning Serving and Packaging_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/3ufq02w9j454m4t83egls/Introduction-to-Machine-Learning-Serving-and-Packaging_v2.pdf?rlkey=5snxqej54rw2iq1g8qf2wyi0k&st=89ocvqd9&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/3ufq02w9j454m4t83egls/Introduction-to-Machine-Learning-Serving-and-Packaging_v2.pdf?rlkey=5snxqej54rw2iq1g8qf2wyi0k&st=89ocvqd9&dl=1",
                view: true,
              },
            ],
          },
          {
            title:
              "Lesson 5.10: Pytorch Framework (Implementation for regression and classification) (1)",
            key: "V10(1)",
            video:
              "https://www.dropbox.com/scl/fi/exckseo1j33f55whwcq29/M05MC-Pytorch-Framework-Implementation-for-regression-and-classification-Zoom.mp4?rlkey=3qogk8irhuwtuuuq4loha62ht&st=soumllfa&raw=1",
            document: [
              {
                title: "Pytorch_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/gtsull2ckrcbp3xtlnn43/Pytorch_v2.pdf?rlkey=a40tusvvt2rxes0xl7n75pt5y&st=hhp99ji0&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/gtsull2ckrcbp3xtlnn43/Pytorch_v2.pdf?rlkey=a40tusvvt2rxes0xl7n75pt5y&st=hhp99ji0&dl=1",
                view: true,
              },
            ],
          },
          {
            title:
              "Lesson 5.11: Pytorch Framework (Implementation for regression and classification) (2)",
            key: "V10(2)",
            video:
              "https://www.dropbox.com/scl/fi/cn5h1yx7ek1bv3k3j373m/M05MC-Pytorch-Framework-Implementation-for-regression-and-classification-Zoom-1.mp4?rlkey=egug6knpgun7v898nukw0z1h0&st=p4xo5g9b&raw=1",
            document: [
              {
                title: "Pytorch_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/gtsull2ckrcbp3xtlnn43/Pytorch_v2.pdf?rlkey=a40tusvvt2rxes0xl7n75pt5y&st=hhp99ji0&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/gtsull2ckrcbp3xtlnn43/Pytorch_v2.pdf?rlkey=a40tusvvt2rxes0xl7n75pt5y&st=hhp99ji0&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.12: Metric for Regression",
            key: "V11",
            video:
              "https://www.dropbox.com/scl/fi/smar5ipbzpn4s3l29lir2/Metric-for-Regression.mp4?rlkey=ze7o8ccqd6o6uieztjexdvdz3&st=hn37d71w&raw=1",
            document: [
              {
                title: "Metric for regression_v3.pdf",
                link: "https://www.dropbox.com/scl/fi/ro868yj6l8eufmpg189ii/Metric-for-regression_v3.pdf?rlkey=2ooic6334c4eigrhloewb3quo&st=sk4vg18g&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/ro868yj6l8eufmpg189ii/Metric-for-regression_v3.pdf?rlkey=2ooic6334c4eigrhloewb3quo&st=sk4vg18g&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.13: TA-Exercise week 2",
            key: "V12",
            video:
              "https://www.dropbox.com/scl/fi/fpsezlvndrsny2ntepms0/M05MC-TA-Exercise-Zoom-2.mp4?rlkey=mm67aifrwyf0td8rretv0iwvy&st=ypdv911x&raw=1",
            document: [
              {
                title: "[Slide]-Exercise_Softmax_Regression_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/uwc2qxq6a348dzan9d505/Slide-Exercise_Softmax_Regression_v2.pdf?rlkey=c3yx85tk0c574r59nlui9zniq&st=7mtn4cej&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/uwc2qxq6a348dzan9d505/Slide-Exercise_Softmax_Regression_v2.pdf?rlkey=c3yx85tk0c574r59nlui9zniq&st=7mtn4cej&dl=1",
                view: true,
              },
              {
                title: "[Description]_Exercise_Softmax_Regression.pdf",
                link: "https://www.dropbox.com/scl/fi/kfpjdvw4d0rhh7h8fl289/Description-_Exercise_Softmax_Regression.pdf?rlkey=yeiitvema0r72k4fgjcu3484w&st=rnyxvkts&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/kfpjdvw4d0rhh7h8fl289/Description-_Exercise_Softmax_Regression.pdf?rlkey=yeiitvema0r72k4fgjcu3484w&st=rnyxvkts&dl=1",
                view: true,
              },
              {
                title: "[Hint]_Card_Fraud_Detection.ipynb",
                link: "https://www.dropbox.com/scl/fi/tu3rmiydjbtzk2t1kv39q/Hint-_Card_Fraud_Detection.ipynb?rlkey=e4411a2lknz5bwn0062oes5fg&st=s9wrull9&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/tu3rmiydjbtzk2t1kv39q/Hint-_Card_Fraud_Detection.ipynb?rlkey=e4411a2lknz5bwn0062oes5fg&st=s9wrull9&dl=1",
                view: false,
              },
              {
                title: "[Hint]_Pytorch_Twitter_Sentiment_Analysis.ipynb",
                link: "https://www.dropbox.com/scl/fi/h4jyrq8np1yv13zihslgn/Hint-_Pytorch_Twitter_Sentiment_Analysis.ipynb?rlkey=ghpmcg4d7al61ik8umdv9gbn9&st=he2ul479&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/h4jyrq8np1yv13zihslgn/Hint-_Pytorch_Twitter_Sentiment_Analysis.ipynb?rlkey=ghpmcg4d7al61ik8umdv9gbn9&st=he2ul479&dl=1",
                view: false,
              },
              {
                title: "[Hint]_Twitter_Sentiment_Analysis.ipynb",
                link: "https://www.dropbox.com/scl/fi/gnjq0g2ya0prsm97zk8ru/Hint-_Twitter_Sentiment_Analysis.ipynb?rlkey=f7bnhn1pufe9kpu7f7fspp2qs&st=5zfuoyns&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/gnjq0g2ya0prsm97zk8ru/Hint-_Twitter_Sentiment_Analysis.ipynb?rlkey=f7bnhn1pufe9kpu7f7fspp2qs&st=5zfuoyns&dl=1",
                view: false,
              },
              {
                title: "creditcard.csv",
                link: "https://www.dropbox.com/scl/fi/dlxzmcvi4yayz867bea6p/creditcard.csv?rlkey=qgfw2obngge6cfz26pwpr47q0&st=h23w53tu&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/dlxzmcvi4yayz867bea6p/creditcard.csv?rlkey=qgfw2obngge6cfz26pwpr47q0&st=h23w53tu&dl=1",
                view: false,
              },
              {
                title: "Twitter_Data.csv",
                link: "https://www.dropbox.com/scl/fi/ywmp37j4rqo3mrz7epz5s/Twitter_Data.csv?rlkey=prr981k9btyhqduye3wpj5oee&st=zdrk1143&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/ywmp37j4rqo3mrz7epz5s/Twitter_Data.csv?rlkey=prr981k9btyhqduye3wpj5oee&st=zdrk1143&dl=1",
                view: false,
              },
            ],
          },
          // week 3
          {
            title: "WEEK 3 -- Exercise, Document and Study Guide",
            key: "W3M5",
            video: " ",
            document: [
              {
                title: "M05W03 - Study Guide.pdf",
                link: "https://www.dropbox.com/scl/fi/8lakqkgyfyulgrl850gbn/M05W03-Study-Guide.pdf?rlkey=6w6t8h42qfyoqu0lvk0awpqsx&st=uenyjrt6&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/8lakqkgyfyulgrl850gbn/M05W03-Study-Guide.pdf?rlkey=6w6t8h42qfyoqu0lvk0awpqsx&st=uenyjrt6&dl=1",
                view: true,
              },

              {
                title: "[Description]_Exercise_MLP_Activations.pdf",
                link: "https://www.dropbox.com/scl/fi/y1l7ih3ub2s4trv7o88l6/Description-_Exercise_MLP_Activations.pdf?rlkey=pej6979gfjux7alg9zdlyuhir&st=f68h4en5&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/y1l7ih3ub2s4trv7o88l6/Description-_Exercise_MLP_Activations.pdf?rlkey=pej6979gfjux7alg9zdlyuhir&st=f68h4en5&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.14: Multilayer Perceptron",
            key: "V13",
            video:
              "https://www.dropbox.com/scl/fi/xdn75rvys6ycayhdxz0fp/M05EC-Basic-Multilayer-Perceptron-Zoom.mp4?rlkey=s9zgk5jnl4ejf7fgkha83oibc&st=gkd6zo45&raw=1",
            document: [
              {
                title: "[Slide]-MLP.pdf",
                link: "https://www.dropbox.com/scl/fi/jhxz7m4fg2tg5px8op4np/Slide-MLP.pdf?rlkey=0sn0jvs2d5xp99palfa5zxm0j&st=7s9u44ap&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/jhxz7m4fg2tg5px8op4np/Slide-MLP.pdf?rlkey=0sn0jvs2d5xp99palfa5zxm0j&st=7s9u44ap&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.15: Basic Multilayer Perceptron (1)",
            key: "V14-1",
            video:
              "https://www.dropbox.com/scl/fi/v37x6qep29vjzcnykyj2w/M05MC-Multilayer-Perceptron-Zoom.mp4?rlkey=0l64lp6k2bd384t7h4pxywypm&st=8quucim3&raw=1",
            document: [
              {
                title: "MultilayerPerceptron_v3.pdf",
                link: "https://www.dropbox.com/scl/fi/7f4xnr5zvidfykxb0qqy8/MultilayerPerceptron_v3.pdf?rlkey=dt4v51vnesd3ycrf11pi622uz&st=hd44qvlg&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/7f4xnr5zvidfykxb0qqy8/MultilayerPerceptron_v3.pdf?rlkey=dt4v51vnesd3ycrf11pi622uz&st=hd44qvlg&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.16: Basic Multilayer Perceptron (2)",
            key: "V14-2",
            video:
              "https://www.dropbox.com/scl/fi/rejf0d54q6atekjd7jwvc/M05MC-Multilayer-Perceptron-Zoom-1.mp4?rlkey=o8x4v0d9deqh9f925gsezkyyb&st=9m20uwij&raw=1",
            document: [
              {
                title: "MultilayerPerceptron_v3.pdf",
                link: "https://www.dropbox.com/scl/fi/7f4xnr5zvidfykxb0qqy8/MultilayerPerceptron_v3.pdf?rlkey=dt4v51vnesd3ycrf11pi622uz&st=hd44qvlg&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/7f4xnr5zvidfykxb0qqy8/MultilayerPerceptron_v3.pdf?rlkey=dt4v51vnesd3ycrf11pi622uz&st=hd44qvlg&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.17: Loss Functions for Classification",
            key: "V15",
            video:
              "https://www.dropbox.com/scl/fi/1j4on62txah9xivt4a4uo/M05EC05-Loss-Functions-for-Classification-Zoom.mp4?rlkey=t776szbkufnv5vpzsalqrcgpr&st=5jyq2l5c&raw=1",
            document: [
              {
                title: "Loss function for Classification_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/5gdu8vzxmzn74z5chp00d/Loss-function-for-Classification_v2.pdf?rlkey=tqqsip0rn8buduy3eyf5tbz4g&st=9vahyf2s&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/5gdu8vzxmzn74z5chp00d/Loss-function-for-Classification_v2.pdf?rlkey=tqqsip0rn8buduy3eyf5tbz4g&st=9vahyf2s&dl=1",
                view: true,
              },
            ],
          },

          {
            title: "Lesson 5.18: Insight into MLP",
            key: "V16",
            video:
              "https://www.dropbox.com/scl/fi/i0tx4yyl8gqbsoxlh7ywd/M05MC-Insight-into-MLP-Zoom.mp4?rlkey=0t70hunppq604jbonr5i2d80j&st=cfwx4xo8&raw=1",
            document: [
              {
                title: "Insight into MLP_v4.pdf",
                link: "https://www.dropbox.com/scl/fi/x2tyfcvrrjw99zzqs5eg1/Insight-into-MLP_v4.pdf?rlkey=hhmkerelt9f8nj4n7rr1xic7h&st=n6j58qzz&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/x2tyfcvrrjw99zzqs5eg1/Insight-into-MLP_v4.pdf?rlkey=hhmkerelt9f8nj4n7rr1xic7h&st=n6j58qzz&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.19: Triton Inference Server",
            key: "V17",
            video:
              "https://www.dropbox.com/scl/fi/h0qobpddpy72kkdqto2gz/M05EC07-Triton-Inference-Server-Zoom.mp4?rlkey=1jn9rb1gyl3eqlpb7ssf12nbh&st=iytr3wrv&raw=1",
            document: [
              {
                title: "[Slide]-Triton Inference Server.pdf",
                link: "https://www.dropbox.com/scl/fi/af3qvzuwntwezwmugl3cv/Slide-Triton-Inference-Server.pdf?rlkey=ec8zbwccaihein782huyxyfln&st=1uq6hryj&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/af3qvzuwntwezwmugl3cv/Slide-Triton-Inference-Server.pdf?rlkey=ec8zbwccaihein782huyxyfln&st=1uq6hryj&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.20: TA Exercise week 3",
            key: "V18",
            video:
              "https://www.dropbox.com/scl/fi/wbon1ccse0rr631zgy9qg/M05MC-TA-EXERCISE-Zoom.mp4?rlkey=dsc6lwr6r0glaj5accmtxysc0&st=98p55uhk&raw=1",
            document: [
              {
                title: "[Description]_Exercise_MLP_Activations.pdf",
                link: "https://www.dropbox.com/scl/fi/4evfuyq3l6wg1pejc0xsp/Description-_Exercise_MLP_Activations.pdf?rlkey=i28m3tgr7g9soe7c3paxivb1o&st=b87mij2v&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/4evfuyq3l6wg1pejc0xsp/Description-_Exercise_MLP_Activations.pdf?rlkey=i28m3tgr7g9soe7c3paxivb1o&st=b87mij2v&dl=1",
                view: true,
              },
              {
                title: "AIO2024_Module05_Exercise_MLP_Activations_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/nfx1gmfvn1td3g2zpgc51/AIO2024_Module05_Exercise_MLP_Activations_v2.pdf?rlkey=9y4p27od2b3ocxc8jegqi0jvt&st=yo6418ar&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/nfx1gmfvn1td3g2zpgc51/AIO2024_Module05_Exercise_MLP_Activations_v2.pdf?rlkey=9y4p27od2b3ocxc8jegqi0jvt&st=yo6418ar&dl=1",
                view: true,
              },
              {
                title: "[Hint]_A_ImgClf_MLP_ReLU.ipynb",
                link: "https://www.dropbox.com/scl/fi/yexxnpq4ki10hmfplaise/Hint-_A_ImgClf_MLP_ReLU.ipynb?rlkey=e43hszaj3i6g2em8d9kgvuoz6&st=7ls695l3&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/yexxnpq4ki10hmfplaise/Hint-_A_ImgClf_MLP_ReLU.ipynb?rlkey=e43hszaj3i6g2em8d9kgvuoz6&st=7ls695l3&dl=1",
                view: false,
              },
              {
                title: "[Hint]_A_NonLinear_MLP_ReLU.ipynb",
                link: "https://www.dropbox.com/scl/fi/srx7t3flh1zgmavftc2wl/Hint-_A_NonLinear_MLP_ReLU.ipynb?rlkey=0b1qrlm3qeq1of8oxsw7xzpnf&st=pwwjpoew&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/srx7t3flh1zgmavftc2wl/Hint-_A_NonLinear_MLP_ReLU.ipynb?rlkey=0b1qrlm3qeq1of8oxsw7xzpnf&st=pwwjpoew&dl=1",
                view: false,
              },
              {
                title: "[Hint]_A_Regression_MLP_ReLU.ipynb",
                link: "https://www.dropbox.com/scl/fi/3v58kn2ylaqj4d65jnmlt/Hint-_A_Regression_MLP_ReLU.ipynb?rlkey=33329lse3nv75h3nna02y5csd&st=vpjxa7hb&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/3v58kn2ylaqj4d65jnmlt/Hint-_A_Regression_MLP_ReLU.ipynb?rlkey=33329lse3nv75h3nna02y5csd&st=vpjxa7hb&dl=1",
                view: false,
              },
            ],
          },
          // week 4
          {
            title: "WEEK 4 -- Exercise, Document and Study Guide",
            key: "",
            video: " ",
            document: [
              {
                title: "Exercise - Optimizer.pdf",
                link: "https://www.dropbox.com/scl/fi/ndbz75s82pnw8uqcp2buk/Exercise-Optimizer.pdf?rlkey=n4aganskvtam748z26zljls6k&st=lh13j2sw&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/ndbz75s82pnw8uqcp2buk/Exercise-Optimizer.pdf?rlkey=n4aganskvtam748z26zljls6k&st=lh13j2sw&dl=1",
                view: true,
              },
              {
                title: "M05W04 - Study Guide.pdf",
                link: "https://www.dropbox.com/scl/fi/thoyh0p78o8609alt6aeg/M05W04-Study-Guide.pdf?rlkey=tibiyahka5thrgdzcwjwn3fhv&st=jp35vw6t&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/thoyh0p78o8609alt6aeg/M05W04-Study-Guide.pdf?rlkey=tibiyahka5thrgdzcwjwn3fhv&st=jp35vw6t&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.21: SGD",
            key: "V19",
            video:
              "https://www.dropbox.com/scl/fi/2ahqe7i27nu12psq4zm6l/M05EC03-SGD-Zoom.mp4?rlkey=8hbf77mjs1rq5a7n6jmdzean7&st=nw43pxf2&raw=1",
            document: [
              {
                title: "[Slide]-SGD-Momentum_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/9kk20zi8ig5h8zffk20vx/Slide-SGD-Momentum_v2.pdf?rlkey=xcls65epeefuqvivmqom272x7&st=7uyn799t&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/9kk20zi8ig5h8zffk20vx/Slide-SGD-Momentum_v2.pdf?rlkey=xcls65epeefuqvivmqom272x7&st=7uyn799t&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.22: Model Initialization",
            key: "V20",
            video:
              "https://www.dropbox.com/scl/fi/l0k7utwxasa8cpzd4fip8/M05MC-Model-Initialization-Zoom.mp4?rlkey=qcedezqqxefp97eox3yuetutk&st=r4yi9cn0&raw=1",
            document: [
              {
                title: "Initializers_v5.pdf",
                link: "https://www.dropbox.com/scl/fi/fkrq3fj4eug5bt9vmb706/Initializers_v5.pdf?rlkey=7k2p756qunwt1jtggdeecgqsw&st=29s4ztfg&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/fkrq3fj4eug5bt9vmb706/Initializers_v5.pdf?rlkey=7k2p756qunwt1jtggdeecgqsw&st=29s4ztfg&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.23: Organizing code for an AI project",
            key: "V21",
            video:
              "https://www.dropbox.com/scl/fi/79se5050yn6skkgozwsia/M05EC05-T-ch-c-code-cho-m-t-d-n-AI-Zoom.mp4?rlkey=78k8ei8v2y4s0g837ttv9b8x4&st=5tn3si38&raw=1",
            document: [
              {
                title: "A Guide to Organizing Machine Learning Projects_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/vb7zkglpp3fnkpgzd7679/A-Guide-to-Organizing-Machine-Learning-Projects_v2.pdf?rlkey=20jfz5m2f7906j7pzwtku6u82&st=9utoadul&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/vb7zkglpp3fnkpgzd7679/A-Guide-to-Organizing-Machine-Learning-Projects_v2.pdf?rlkey=20jfz5m2f7906j7pzwtku6u82&st=9utoadul&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.24: Optimizers for Neural Networks",
            key: "V22",
            video:
              "https://www.dropbox.com/scl/fi/r9ghy5tj32m8h4s490075/M05MC-Optimizers-for-Neural-Networks-Zoom.mp4?rlkey=gb6c0srdtqs8mcd5qr8c7d6dv&st=po5uami0&raw=1",
            document: [
              {
                title: "Optimizers_v5.pdf",
                link: "https://www.dropbox.com/scl/fi/ysjgprc5izud3sbesmstm/Optimizers_v5.pdf?rlkey=3pn3psq28eyk74x38evwyrnor&st=fml5udbr&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/ysjgprc5izud3sbesmstm/Optimizers_v5.pdf?rlkey=3pn3psq28eyk74x38evwyrnor&st=fml5udbr&dl=1",
                view: true,
              },
              {
                title: "opt_animation.ipynb",
                link: "https://www.dropbox.com/scl/fi/fsb5iehcnu7o6lmwpovtq/opt_animation.ipynb?rlkey=vgw04qug7572cu20s9xqviyuf&st=imaqdqx2&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/fsb5iehcnu7o6lmwpovtq/opt_animation.ipynb?rlkey=vgw04qug7572cu20s9xqviyuf&st=imaqdqx2&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.25: Metric for Classification",
            key: "V23",
            video:
              "https://www.dropbox.com/scl/fi/ye3pd7hoxwik4f9p5w8gp/M05EC07-Metric-for-Classification-Zoom.mp4?rlkey=fgxnjfs13e9zhttlp6qgc2ua6&st=8x7odxew&raw=1",
            document: [
              {
                title: "metric_for_classification_v3.pdf",
                link: "https://www.dropbox.com/scl/fi/hcehcsilroqyz9sgpthx7/metric_for_classification_v3.pdf?rlkey=ry63m90nn7u8k8tsfittwuco4&st=0s8isoz6&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/hcehcsilroqyz9sgpthx7/metric_for_classification_v3.pdf?rlkey=ry63m90nn7u8k8tsfittwuco4&st=0s8isoz6&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5.26: TA Exercise week 4",
            key: "V24",
            video:
              "https://www.dropbox.com/scl/fi/exoze7lys66uqbg0s2awl/M05MC-TA-Exercise-Zoom-4.mp4?rlkey=1siw2cto66m91bsq5qz3t7l4r&st=a7ykaxau&raw=1",
            document: [
              {
                title: "Exercise - Optimizer.pdf",
                link: "https://www.dropbox.com/scl/fi/gzg6ymohagp4ye98t6msn/Exercise-Optimizer.pdf?rlkey=61k7ba6irldbyox9dk34v2zuo&st=atrzf39y&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/gzg6ymohagp4ye98t6msn/Exercise-Optimizer.pdf?rlkey=61k7ba6irldbyox9dk34v2zuo&st=atrzf39y&dl=1",
                view: true,
              },
              {
                title: "[Slide]-Optimizer_TA_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/k2njk43c0veamfj5e7hz5/Slide-Optimizer_TA_v2.pdf?rlkey=b81afx1d2va16kb3qvd0gxlqt&st=fxsoap82&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/k2njk43c0veamfj5e7hz5/Slide-Optimizer_TA_v2.pdf?rlkey=b81afx1d2va16kb3qvd0gxlqt&st=fxsoap82&dl=1",
                view: true,
              },
              {
                title: "[Hint]5_Optimizers.ipynb",
                link: "https://www.dropbox.com/scl/fi/8oslwx24m098lz6nwdbdg/Hint-5_Optimizers.ipynb?rlkey=ltgxd9k0g1h3pbnrrdw5v7foi&st=6qjo00ic&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/8oslwx24m098lz6nwdbdg/Hint-5_Optimizers.ipynb?rlkey=ltgxd9k0g1h3pbnrrdw5v7foi&st=6qjo00ic&dl=1",
                view: false,
              },
              {
                title: "[hint]4d_Adam.ipynb",
                link: "https://www.dropbox.com/scl/fi/rapz6px96occnal6ezpx0/hint-4d_Adam.ipynb?rlkey=jiej4qp1nez83meuxyinwwvkp&st=ww7yqm2d&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/rapz6px96occnal6ezpx0/hint-4d_Adam.ipynb?rlkey=jiej4qp1nez83meuxyinwwvkp&st=ww7yqm2d&dl=1",
                view: false,
              },
              {
                title: "[hint]3b_RMSProp.ipynb",
                link: "https://www.dropbox.com/scl/fi/mp4irf3fiu9ucsfsuhlj1/hint-3b_RMSProp.ipynb?rlkey=qjlkpa45u98ic5g6itx6kceyw&st=mezcfhzk&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/mp4irf3fiu9ucsfsuhlj1/hint-3b_RMSProp.ipynb?rlkey=qjlkpa45u98ic5g6itx6kceyw&st=mezcfhzk&dl=1",
                view: false,
              },
              {
                title: "[hint]2b_GD_Momentum.ipynb",
                link: "https://www.dropbox.com/scl/fi/xurwozj65ubbpz50uylh6/hint-2b_GD_Momentum.ipynb?rlkey=n6f42s2injpf1bwtha6abylz3&st=9n0bg01q&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/xurwozj65ubbpz50uylh6/hint-2b_GD_Momentum.ipynb?rlkey=n6f42s2injpf1bwtha6abylz3&st=9n0bg01q&dl=1",
                view: false,
              },
              {
                title: "[hint]1b_GD.ipynb",
                link: "https://www.dropbox.com/scl/fi/ipnkfsc5zv4kyrrf2cu2z/hint-1b_GD.ipynb?rlkey=9v21r8526hjy1mli1b0dxxiwd&st=ckk3d09s&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/ipnkfsc5zv4kyrrf2cu2z/hint-1b_GD.ipynb?rlkey=9v21r8526hjy1mli1b0dxxiwd&st=ckk3d09s&dl=1",
                view: false,
              },
              {
                title: "adopt.py",
                link: "https://www.dropbox.com/scl/fi/be6a4kkiseg7iellwho2r/adopt.py?rlkey=51245jgk3cjm90z20wwus5m2b&st=f4ejztyh&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/be6a4kkiseg7iellwho2r/adopt.py?rlkey=51245jgk3cjm90z20wwus5m2b&st=f4ejztyh&dl=1",
                view: true,
              },
              {
                title: "[hint]5e_ADOPT.ipynb",
                link: "https://www.dropbox.com/scl/fi/084lnvt6ryy65nlm143bk/hint-5e_ADOPT.ipynb?rlkey=bh5fhnpfxlcy6uhxkzbbx7qze&st=f88ynepn&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/084lnvt6ryy65nlm143bk/hint-5e_ADOPT.ipynb?rlkey=bh5fhnpfxlcy6uhxkzbbx7qze&st=f88ynepn&dl=1",
                view: true,
              },
            ],
          },
          // WEEK 5
          {
            title: "WEEK 5 -- Exercise, Document and Study Guide",
            key: "W5M5",
            video: " ",
            document: [
              {
                title: "M05W05 - Study Guide.pdf",
                link: "https://www.dropbox.com/scl/fi/vlxgj5jhg55swucf1w7a7/M05W05-Study-Guide.pdf?rlkey=pauistynp6di3d4g4hg5xq6tz&st=s9swsmqi&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/vlxgj5jhg55swucf1w7a7/M05W05-Study-Guide.pdf?rlkey=pauistynp6di3d4g4hg5xq6tz&st=s9swsmqi&dl=1",
                view: true,
              },
              {
                title: "Light Controlling Using Hand Gestures.pdf",
                link: "https://www.dropbox.com/scl/fi/33huo4do6pohhi642zwuw/Light-Controlling-Using-Hand-Gestures.pdf?rlkey=m0nlhfze25254vxnrejg8zri9&st=6p1lkn5c&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/33huo4do6pohhi642zwuw/Light-Controlling-Using-Hand-Gestures.pdf?rlkey=m0nlhfze25254vxnrejg8zri9&st=6p1lkn5c&dl=1",
                view: true,
              },
            ],
          },
          {
            title:
              "Lesson 5.27: IoT Project: Ligh Controlling Using Hand Guestures",
            key: "V25",
            video:
              "https://www.dropbox.com/scl/fi/lw3l68lmdu0667l4xyvzu/M05MC-IoT-Project-Ligh-Controlling-Using-Hand-Guestures-Zoom.mp4?rlkey=cmjv3lwx2vyiko456yxzhaiax&st=0uu3zztr&raw=1",
            document: [
              {
                title: "Light Controlling Using Hand Gestures.pdf",
                link: "https://www.dropbox.com/scl/fi/z5duugxesugsqfkwfnq26/Light-Controlling-Using-Hand-Gestures.pdf?rlkey=0ieafp1d62tuzpqt0cpnccqj4&st=u2bii8i9&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/z5duugxesugsqfkwfnq26/Light-Controlling-Using-Hand-Gestures.pdf?rlkey=0ieafp1d62tuzpqt0cpnccqj4&st=u2bii8i9&dl=1",
                view: true,
              },
              {
                title: "Light Controlling Using Hand Gestures.pdf",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title:
              "Lesson 5.28: Architecture Project: Gradient Vanishing in MLP",
            key: "V26",
            video:
              "https://www.dropbox.com/scl/fi/eg8px2lz1akd7w8b1qsj4/M05MC-Architecture-Project-Gradient-Vanishing-in-MLP-Zoom.mp4?rlkey=ym61ipmlifm2874kuhwckplp4&st=9r13sq08&raw=1",
            document: [
              {
                title: "[Description]_Project_Vanishing_Gradient_v4.pdf",
                link: "https://www.dropbox.com/scl/fi/gbgxir97uox1brcv0ae6a/Description-_Project_Vanishing_Gradient_v4.pdf?rlkey=19g4uku4d13e43smehqi2zlh5&st=nwfqt6c1&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/gbgxir97uox1brcv0ae6a/Description-_Project_Vanishing_Gradient_v4.pdf?rlkey=19g4uku4d13e43smehqi2zlh5&st=nwfqt6c1&dl=1",
                view: true,
              },
              {
                title: "[Slide]-Project_Vanishing_Gradient_v4.pdf",
                link: "https://www.dropbox.com/scl/fi/hflbi7tvxjsjk4prp5qgf/Slide-Project_Vanishing_Gradient_v4.pdf?rlkey=o9jqoj8f6ik83zt9lj4t8nqcc&st=vkf9qwab&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/hflbi7tvxjsjk4prp5qgf/Slide-Project_Vanishing_Gradient_v4.pdf?rlkey=o9jqoj8f6ik83zt9lj4t8nqcc&st=vkf9qwab&dl=1",
                view: true,
              },
            ],
          },
        ],
      },
      Module6: {
        title: "Module 6: Deep Learning Basics",
        children: [
          // week 1
          {
            title: "WEEK 1 -- Exercise, Document and Study Guide",
            key: "viw1",
            video: " ",
            document: [
              {
                title: "M06W01 - Study Guide.pdf",
                link: "https://www.dropbox.com/scl/fi/55uye56ro1o8n8wk71jd8/M06W01-Study-Guide.pdf?rlkey=5ibt79red3brbtb4hwy851bsc&st=sm5b57ed&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/55uye56ro1o8n8wk71jd8/M06W01-Study-Guide.pdf?rlkey=5ibt79red3brbtb4hwy851bsc&st=sm5b57ed&dl=1",
                view: true,
              },
              {
                title: "[Description]-CNN-Applications.pdf",
                link: "https://www.dropbox.com/scl/fi/4n9e8gph89al5094iv0qi/Description-CNN-Applications.pdf?rlkey=6q9mbn6k9n4kx3ehywz8fpg9i&st=vdbj0o6r&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/4n9e8gph89al5094iv0qi/Description-CNN-Applications.pdf?rlkey=6q9mbn6k9n4kx3ehywz8fpg9i&st=vdbj0o6r&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.1: Introduction to CNN",
            key: "vi1",
            video:
              "https://www.dropbox.com/scl/fi/z7h4qta7n79cqowecklnh/M06EC-Introduction-to-CNN-Zoom.mp4?rlkey=9p38fc61n4b790rbzjsfskfjp&st=zqqo1x6s&raw=1",
            document: [
              {
                title: "Introduction to CNN_v3.pdf",
                link: "https://www.dropbox.com/scl/fi/2j1umqpqffwp61q05cbr8/Introduction-to-CNN_v3.pdf?rlkey=b4e6cpn1cjcuf4jdumf40epo0&st=r8joa3b9&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/2j1umqpqffwp61q05cbr8/Introduction-to-CNN_v3.pdf?rlkey=b4e6cpn1cjcuf4jdumf40epo0&st=r8joa3b9&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.2: From MLP to CNN (1)",
            key: "vi2.1",
            video:
              "https://www.dropbox.com/scl/fi/640s8zfm6d8eidnar5qq4/M06MC04-From-MLP-to-CNN-Zoom.mp4?rlkey=7z7lxl2l2yy4idi5jwc5qdsb8&st=gifdeljy&raw=1",
            document: [
              {
                title: "From MLP to CNN_v6.pdf",
                link: "https://www.dropbox.com/scl/fi/yyr52w0ni7nj41lmqtynw/From-MLP-to-CNN_v6.pdf?rlkey=bxh43upgyxiy46kfvqfl9l8e0&st=y7948r1j&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/yyr52w0ni7nj41lmqtynw/From-MLP-to-CNN_v6.pdf?rlkey=bxh43upgyxiy46kfvqfl9l8e0&st=y7948r1j&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.2: From MLP to CNN (2)",
            key: "vi2.2",
            video:
              "https://www.dropbox.com/scl/fi/3qnggdhighyykrcnja0mg/M06MC04-From-MLP-to-CNN-Zoom-1.mp4?rlkey=m0hlr9amr5pa5s50o7tvxrzum&st=e3c4m2jn&raw=1",
            document: [
              {
                title: "From MLP to CNN_v6.pdf",
                link: "https://www.dropbox.com/scl/fi/yyr52w0ni7nj41lmqtynw/From-MLP-to-CNN_v6.pdf?rlkey=bxh43upgyxiy46kfvqfl9l8e0&st=y7948r1j&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/yyr52w0ni7nj41lmqtynw/From-MLP-to-CNN_v6.pdf?rlkey=bxh43upgyxiy46kfvqfl9l8e0&st=y7948r1j&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.3: AirFlow for Scheduling",
            key: "vi3",
            video:
              "https://www.dropbox.com/scl/fi/inelcz7mg3tf0nj1b5jld/M06EC05-AirFlow-for-Scheduling-Zoom.mp4?rlkey=fw58pw0a84c48azzq67kps2uz&st=7sklt1wn&raw=1",
            document: [
              {
                title: "Airflow_v3.pdf",
                link: "https://www.dropbox.com/scl/fi/jxsr3p2gizyqe2mbhji3h/Airflow_v3.pdf?rlkey=c6u5nxq7d4td8oqud0zwi3lof&st=p1w48hij&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/jxsr3p2gizyqe2mbhji3h/Airflow_v3.pdf?rlkey=c6u5nxq7d4td8oqud0zwi3lof&st=p1w48hij&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.4: How to train CNNs",
            key: "vi4",
            video:
              "https://www.dropbox.com/scl/fi/fkrg2q2c24uoyiilepcuq/M06MC06-How-to-train-CNNs-Zoom.mp4?rlkey=u2x5nbagb4lmz9ftgfwblxbrf&st=5hneaap8&raw=1",
            document: [
              {
                title: "How to train CNNs_v3.pdf",
                link: "https://www.dropbox.com/scl/fi/ii8faxyp1oaqlm9mq4ius/How-to-train-CNNs_v3.pdf?rlkey=sib4a9zxpszkvmeb2q7fxs492&st=4lax40t1&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/ii8faxyp1oaqlm9mq4ius/How-to-train-CNNs_v3.pdf?rlkey=sib4a9zxpszkvmeb2q7fxs492&st=4lax40t1&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.5: Mamba (1)-(1)",
            key: "vi5.1",
            video:
              "https://www.dropbox.com/scl/fi/t096uqoahilysnhgjsdej/M06EC07-Mamba-1-Zoom.mp4?rlkey=e9ydr59xs5y2f1kw05zuyxndh&st=ykbhejsx&raw=1",
            document: [
              {
                title: "Mamba_Basic_v4.pdf",
                link: "https://www.dropbox.com/scl/fi/rvi0gugd8a5sth2rqyq1l/Mamba_Basic_v4.pdf?rlkey=wvxsccmmc498xvus6oqphsfv1&st=6i96xlc2&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/rvi0gugd8a5sth2rqyq1l/Mamba_Basic_v4.pdf?rlkey=wvxsccmmc498xvus6oqphsfv1&st=6i96xlc2&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.5: Mamba (1)-(2)",
            key: "vi5.2",
            video:
              "https://www.dropbox.com/scl/fi/0e3cykl9ue43lkqp2rv10/M06EC07-Mamba-1-Zoom-1.mp4?rlkey=kkpkqoml6xe9o4olgo4zq0yrp&st=befnvgcr&raw=1",
            document: [
              {
                title: "Mamba_Basic_v4.pdf",
                link: "https://www.dropbox.com/scl/fi/rvi0gugd8a5sth2rqyq1l/Mamba_Basic_v4.pdf?rlkey=wvxsccmmc498xvus6oqphsfv1&st=6i96xlc2&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/rvi0gugd8a5sth2rqyq1l/Mamba_Basic_v4.pdf?rlkey=wvxsccmmc498xvus6oqphsfv1&st=6i96xlc2&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.6: TA Exercise week 1 (1)",
            key: "vi6.1",
            video:
              "https://www.dropbox.com/scl/fi/s7emsz2jtuyudbotvkzir/M06MC-TA-Exercise-Zoom.mp4?rlkey=5c6jyjpn5dkkk7krbrqbr2x7b&st=jfwibzph&raw=1",
            document: [
              {
                title: "[Description]_Exercise_Advanced_CNNs.pdf",
                link: "https://www.dropbox.com/scl/fi/uximf3uyd8mdb725w3hck/Description-_Exercise_Advanced_CNNs.pdf?rlkey=1yb0mmuliinabug96nj0tev62&st=kkkvq6yi&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/uximf3uyd8mdb725w3hck/Description-_Exercise_Advanced_CNNs.pdf?rlkey=1yb0mmuliinabug96nj0tev62&st=kkkvq6yi&dl=1",
                view: true,
              },
              {
                title: "[Description]-CNN-Applications.pdf",
                link: "https://www.dropbox.com/scl/fi/4n9e8gph89al5094iv0qi/Description-CNN-Applications.pdf?rlkey=6q9mbn6k9n4kx3ehywz8fpg9i&st=j32zglle&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/4n9e8gph89al5094iv0qi/Description-CNN-Applications.pdf?rlkey=6q9mbn6k9n4kx3ehywz8fpg9i&st=j32zglle&dl=1",
                view: true,
              },
              {
                title: "[Slide]-CNN.pdf",
                link: "https://www.dropbox.com/scl/fi/53xsvknc5cpp4ka3sgv1b/Slide-CNN.pdf?rlkey=aj0rkpit0r5vztrihw7wrvzwd&st=kzece57j&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/53xsvknc5cpp4ka3sgv1b/Slide-CNN.pdf?rlkey=aj0rkpit0r5vztrihw7wrvzwd&st=kzece57j&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.6: TA Exercise week 1 (2)",
            key: "vi6.2",
            video:
              "https://www.dropbox.com/scl/fi/5wsh2sk2k6v0zdwvincf5/M06MC-TA-Exercise-Zoom-1.mp4?rlkey=9l6slpx0o7pralbbtlh7ork72&st=3hq6uj2u&raw=1",
            document: [
              {
                title: "[Description]_Exercise_Advanced_CNNs.pdf",
                link: "https://www.dropbox.com/scl/fi/uximf3uyd8mdb725w3hck/Description-_Exercise_Advanced_CNNs.pdf?rlkey=1yb0mmuliinabug96nj0tev62&st=kkkvq6yi&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/uximf3uyd8mdb725w3hck/Description-_Exercise_Advanced_CNNs.pdf?rlkey=1yb0mmuliinabug96nj0tev62&st=kkkvq6yi&dl=1",
                view: true,
              },
              {
                title: "[Description]-CNN-Applications.pdf",
                link: "https://www.dropbox.com/scl/fi/4n9e8gph89al5094iv0qi/Description-CNN-Applications.pdf?rlkey=6q9mbn6k9n4kx3ehywz8fpg9i&st=j32zglle&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/4n9e8gph89al5094iv0qi/Description-CNN-Applications.pdf?rlkey=6q9mbn6k9n4kx3ehywz8fpg9i&st=j32zglle&dl=1",
                view: true,
              },
              {
                title: "[Slide]-CNN.pdf",
                link: "https://www.dropbox.com/scl/fi/53xsvknc5cpp4ka3sgv1b/Slide-CNN.pdf?rlkey=aj0rkpit0r5vztrihw7wrvzwd&st=kzece57j&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/53xsvknc5cpp4ka3sgv1b/Slide-CNN.pdf?rlkey=aj0rkpit0r5vztrihw7wrvzwd&st=kzece57j&dl=1",
                view: true,
              },
            ],
          },
          // week 2
          {
            title: "WEEK 2 -- Exercise, Document and Study Guide",
            key: "viw2",
            video: " ",
            document: [
              {
                title: "M06W02 - Study Guide.pdf",
                link: "https://www.dropbox.com/scl/fi/kpxi7pftoc7rslk715lvv/M06W02-Study-Guide.pdf?rlkey=3410ah5hai2v7zgnwc5ixub2e&st=fovg27hg&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/kpxi7pftoc7rslk715lvv/M06W02-Study-Guide.pdf?rlkey=3410ah5hai2v7zgnwc5ixub2e&st=fovg27hg&dl=1",
                view: true,
              },
              {
                title: "[Description]_Exercise_Advanced_CNNs.pdf",
                link: "https://www.dropbox.com/scl/fi/dspvt5upldlw0du9n9fjj/Description-_Exercise_Advanced_CNNs.pdf?rlkey=tjhj6iimxgsq9v7m3a04vt3rh&st=jhub8qq4&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/dspvt5upldlw0du9n9fjj/Description-_Exercise_Advanced_CNNs.pdf?rlkey=tjhj6iimxgsq9v7m3a04vt3rh&st=jhub8qq4&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.7: Advanced CNN (BN and Dropout)",
            key: "vi7",
            video:
              "https://www.dropbox.com/scl/fi/lk3b716nwyz2rerlh04zs/M06EC03-Advanced-CNN-BN-and-Dropout-Zoom.mp4?rlkey=66v0gw39uf3gevoq6ds93yu8u&st=jqo3tccu&raw=1",
            document: [
              {
                title: "[Slide]-Advanced-CNN.pdf",
                link: "https://www.dropbox.com/scl/fi/ej3f96gv2xlhch6nh5jms/Slide-Advanced-CNN.pdf?rlkey=fznykuvsghx14y92oessz6bh0&st=v19jxhhq&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/ej3f96gv2xlhch6nh5jms/Slide-Advanced-CNN.pdf?rlkey=fznykuvsghx14y92oessz6bh0&st=v19jxhhq&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.8: CNN Training and Generalization (1)",
            key: "vi8.1",
            video:
              "https://www.dropbox.com/scl/fi/25q6veg2widyqsliw1n5z/M06MC04-CNN-Training-and-Generalization-Zoom.mp4?rlkey=pgi9fosm2e5t48rjs47ufdv3l&st=4anuv6rz&raw=1",
            document: [
              {
                title: "[Note]_Project_Vanishing_Gradient_BN.pdf",
                link: "https://www.dropbox.com/scl/fi/t0wsvl6yducd0lxv917ef/Note-_Project_Vanishing_Gradient_BN.pdf?rlkey=akigxtbrlko0vv71r573rp4aw&st=t1h94y0y&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/t0wsvl6yducd0lxv917ef/Note-_Project_Vanishing_Gradient_BN.pdf?rlkey=akigxtbrlko0vv71r573rp4aw&st=t1h94y0y&dl=1",
                view: true,
              },
              {
                title: "Model Generalization_extended.pdf",
                link: "https://www.dropbox.com/scl/fi/qsl4ofi8fg7gwb7unkvah/Model-Generalization_extended.pdf?rlkey=9jxbovehgoq7xgqw7sksjb2uh&st=app7anm3&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/qsl4ofi8fg7gwb7unkvah/Model-Generalization_extended.pdf?rlkey=9jxbovehgoq7xgqw7sksjb2uh&st=app7anm3&dl=1",
                view: true,
              },
              {
                title: "Model Generalization_v3.pdf",
                link: "https://www.dropbox.com/scl/fi/4lkuywz9jfk9o3j0cs1da/Model-Generalization_v3.pdf?rlkey=56fhk93h2kcml0uf1ig9olqr4&st=k3eq3voj&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/4lkuywz9jfk9o3j0cs1da/Model-Generalization_v3.pdf?rlkey=56fhk93h2kcml0uf1ig9olqr4&st=k3eq3voj&dl=1",
                view: true,
              },
              {
                title: "Trick Model (Folder Code)",
                link: " ",
                linkDownload:
                  "https://www.dropbox.com/scl/fo/0xokr6plhwtfkntr03mkt/AJisymqFELhvaM2tsRdHq7E?rlkey=3tvkrk2o2n5x79nevybtmwbb8&st=19tipcy4&dl=1",
                view: false,
              },
            ],
          },
          {
            title: "Lesson 6.8: CNN Training and Generalization (2)",
            key: "vi8.2",
            video:
              "https://www.dropbox.com/scl/fi/pjcz8hdx95lrtnzvchqd7/M06MC04-CNN-Training-and-Generalization-Zoom-1.mp4?rlkey=nfwflnv5w1skdui737o5hxuar&st=ye5elfow&raw=1",
            document: [
              {
                title: "[Note]_Project_Vanishing_Gradient_BN.pdf",
                link: "https://www.dropbox.com/scl/fi/t0wsvl6yducd0lxv917ef/Note-_Project_Vanishing_Gradient_BN.pdf?rlkey=akigxtbrlko0vv71r573rp4aw&st=t1h94y0y&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/t0wsvl6yducd0lxv917ef/Note-_Project_Vanishing_Gradient_BN.pdf?rlkey=akigxtbrlko0vv71r573rp4aw&st=t1h94y0y&dl=1",
                view: true,
              },
              {
                title: "Model Generalization_extended.pdf",
                link: "https://www.dropbox.com/scl/fi/qsl4ofi8fg7gwb7unkvah/Model-Generalization_extended.pdf?rlkey=9jxbovehgoq7xgqw7sksjb2uh&st=app7anm3&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/qsl4ofi8fg7gwb7unkvah/Model-Generalization_extended.pdf?rlkey=9jxbovehgoq7xgqw7sksjb2uh&st=app7anm3&dl=1",
                view: true,
              },
              {
                title: "Model Generalization_v3.pdf",
                link: "https://www.dropbox.com/scl/fi/4lkuywz9jfk9o3j0cs1da/Model-Generalization_v3.pdf?rlkey=56fhk93h2kcml0uf1ig9olqr4&st=k3eq3voj&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/4lkuywz9jfk9o3j0cs1da/Model-Generalization_v3.pdf?rlkey=56fhk93h2kcml0uf1ig9olqr4&st=k3eq3voj&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.9: MLFlow for Model Tracking and Versioning",
            key: "vi9",
            video:
              "https://www.dropbox.com/scl/fi/onynokcyud10fg28o700i/M06EC05-MLFlow-for-Model-Tracking-and-Versioning-Zoom.mp4?rlkey=gw45qk7kkdfzukajm9usomy4c&st=6rd3itd7&raw=1",
            document: [
              {
                title: "MLFlow_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/ptzz29rqqult741ivpq7o/MLFlow_v2.pdf?rlkey=9smiuv8qutexhkw724vkw2i7h&st=0fpqywbw&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/ptzz29rqqult741ivpq7o/MLFlow_v2.pdf?rlkey=9smiuv8qutexhkw724vkw2i7h&st=0fpqywbw&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.10: Advanced CNN Architecture",
            key: "vi10",
            video:
              "https://www.dropbox.com/scl/fi/bpbu4bhg6y6ziiele3adf/M06MC06-Advanced-CNN-Architecture-Zoom.mp4?rlkey=zy7skjt9yrohx8crbe2kpj2du&st=no4rst1q&raw=1",
            document: [
              {
                title: "Advanced CNN_v3.pdf",
                link: "https://www.dropbox.com/scl/fi/g6prk29kpken5v6tivg40/Advanced-CNN_v3.pdf?rlkey=yr964ce5pauk8an27ctd2rzax&st=je0frf3t&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/g6prk29kpken5v6tivg40/Advanced-CNN_v3.pdf?rlkey=yr964ce5pauk8an27ctd2rzax&st=je0frf3t&dl=1",
                view: true,
              },
              {
                title: "image_size_224 (folder)",
                link: "",
                linkDownload:
                  "https://www.dropbox.com/scl/fo/buaq38ozpgbazaaqfo0sd/ANzj5Bp2QkRt_ZWfaNKxeqk?rlkey=jx09r1mt48wqoq3p921b0qv8o&st=b7dlrvls&dl=1",
                view: false,
              },
              {
                title: "image_size_32 (folder)",
                link: " ",
                linkDownload:
                  "https://www.dropbox.com/scl/fo/eqru171ln4xjje0e0615v/AADgBf04yxJdVuCV9SndCn4?rlkey=7rfiygvqb9kmekfmf0hr1cjdk&st=clhi5ee8&dl=1",
                view: false,
              },
            ],
          },
          {
            title: "Lesson 6.11: Mamba (2)",
            key: "vi11",
            video:
              "https://www.dropbox.com/scl/fi/uderweon2d9v1c1q3nxda/M06EC07-Mamba-2-Zoom.mp4?rlkey=6gori88fvldiph9q21uisx8zv&st=wwarxgzl&raw=1",
            document: [
              {
                title: "Mamba-for-vision v2.pdf",
                link: "https://www.dropbox.com/scl/fi/hidca0cdznxpvmkzch2u1/Mamba-for-vision-v2.pdf?rlkey=dd6h8nflpj34cx1knxlqa1ddr&st=0krfj901&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/hidca0cdznxpvmkzch2u1/Mamba-for-vision-v2.pdf?rlkey=dd6h8nflpj34cx1knxlqa1ddr&st=0krfj901&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.12: TA Exercise week 2",
            key: "vi12",
            video:
              "https://www.dropbox.com/scl/fi/ijsfv31bjfwlurnnm6xnc/M06MC-TA-Exercise-Zoom.mp4?rlkey=1f7p50txgu0rrddpizhsp42xl&st=3yg8z0m0&raw=1",
            document: [
              {
                title: "[Description]_Exercise_Advanced_CNNs.pdf",
                link: "https://www.dropbox.com/scl/fi/dspvt5upldlw0du9n9fjj/Description-_Exercise_Advanced_CNNs.pdf?rlkey=tjhj6iimxgsq9v7m3a04vt3rh&st=w17mwsm6&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/dspvt5upldlw0du9n9fjj/Description-_Exercise_Advanced_CNNs.pdf?rlkey=tjhj6iimxgsq9v7m3a04vt3rh&st=w17mwsm6&dl=1",
                view: true,
              },
              {
                title: "[Slide]-Exercise_AdvancedCNN_v3.pdf",
                link: "https://www.dropbox.com/scl/fi/mt75arxtdqokf78x1us9r/Slide-Exercise_AdvancedCNN_v3.pdf?rlkey=uryyhq5nnzk8kxsuo2zzfaypp&st=yhn88p7k&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/mt75arxtdqokf78x1us9r/Slide-Exercise_AdvancedCNN_v3.pdf?rlkey=uryyhq5nnzk8kxsuo2zzfaypp&st=yhn88p7k&dl=1",
                view: true,
              },
            ],
          },
          // week 3
          {
            title: "WEEK 3 -- Exercise, Document and Study Guide",
            key: "viw3",
            video: " ",
            document: [
              {
                title: "RNN_Description.pdf",
                link: "https://www.dropbox.com/scl/fi/hrtwofc8y0irwrspwrjzh/RNN_Description.pdf?rlkey=juo31ysk8f3og2un4y5g0pyzr&st=wdwz8iuo&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/hrtwofc8y0irwrspwrjzh/RNN_Description.pdf?rlkey=juo31ysk8f3og2un4y5g0pyzr&st=wdwz8iuo&dl=1",
                view: true,
              },
              {
                title: "[Report] - Tokenization in NLP.pdf",
                link: "https://www.dropbox.com/scl/fi/2mo7zgxecszhamwap7a3p/Report-Tokenization-in-NLP.pdf?rlkey=ms5shl2c35xsxzk84cnz5dc4d&st=udz7q8g2&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/2mo7zgxecszhamwap7a3p/Report-Tokenization-in-NLP.pdf?rlkey=ms5shl2c35xsxzk84cnz5dc4d&st=udz7q8g2&dl=1",
                view: true,
              },
              {
                title: "M06W03 - Study Guide.pdf",
                link: "https://www.dropbox.com/scl/fi/ynd5vkeozxzh495mz69j0/M06W03-Study-Guide.pdf?rlkey=a6loyq1pp1hrub94rhllew6lz&st=vmi4njnw&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/ynd5vkeozxzh495mz69j0/M06W03-Study-Guide.pdf?rlkey=a6loyq1pp1hrub94rhllew6lz&st=vmi4njnw&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.13: RNN",
            key: "vi13",
            video:
              "https://www.dropbox.com/scl/fi/6ax604i2zcy5bwh07d2en/M06EC03-RNN-Zoom.mp4?rlkey=p0vxghyefdkt0irybuzlz2kcy&st=k0zgrzad&raw=1",
            document: [
              {
                title: "[Slide]- RNN_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/xftzd8n6gr3wwa7snzare/Slide-RNN_v2.pdf?rlkey=vrgg0616y5cv9w7o25byfx10c&st=45tetehg&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/xftzd8n6gr3wwa7snzare/Slide-RNN_v2.pdf?rlkey=vrgg0616y5cv9w7o25byfx10c&st=45tetehg&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.14: Basic RNN (Time-series and Text) (1)",
            key: "vi14.1",
            video:
              "https://www.dropbox.com/scl/fi/hbyjhsm48omjluymzgr46/M06MC04-Basic-RNN-Time-series-and-Text-Zoom.mp4?rlkey=ajrh0kplu5dxbb9sqnuxmu8az&st=0kz9j205&raw=1",
            document: [
              {
                title: "RNNs_v4.pdf",
                link: "https://www.dropbox.com/scl/fi/srw19gckbj5vka0ej2zl9/RNNs_v4.pdf?rlkey=gzfnqfzmlleqxh7favzgsqj0k&st=n7rwn25w&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/srw19gckbj5vka0ej2zl9/RNNs_v4.pdf?rlkey=gzfnqfzmlleqxh7favzgsqj0k&st=n7rwn25w&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.14: Basic RNN (Time-series and Text) (2)",
            key: "vi14.2",
            video:
              "https://www.dropbox.com/scl/fi/w2b1ha3lso21t8qwv4nj9/M06MC04-Basic-RNN-Time-series-and-Text-Zoom-1.mp4?rlkey=anbjmargr93p2v7reduoacppr&st=ddv14gn6&raw=1",
            document: [
              {
                title: "RNNs_v4.pdf",
                link: "https://www.dropbox.com/scl/fi/srw19gckbj5vka0ej2zl9/RNNs_v4.pdf?rlkey=gzfnqfzmlleqxh7favzgsqj0k&st=n7rwn25w&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/srw19gckbj5vka0ej2zl9/RNNs_v4.pdf?rlkey=gzfnqfzmlleqxh7favzgsqj0k&st=n7rwn25w&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.15: Tracking and Logging Applications (1)",
            key: "vi15.1",
            video:
              "https://www.dropbox.com/scl/fi/hbyjhsm48omjluymzgr46/M06MC04-Basic-RNN-Time-series-and-Text-Zoom.mp4?rlkey=ajrh0kplu5dxbb9sqnuxmu8az&st=t07j0fcr&raw=1",
            document: [
              {
                title: "Monitoring.pdf",
                link: "https://www.dropbox.com/scl/fi/ufhpyrb070ejboaleniao/Monitoring.pdf?rlkey=spqiwa7suoqqyl1z4yausabb5&st=mg53inpu&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/ufhpyrb070ejboaleniao/Monitoring.pdf?rlkey=spqiwa7suoqqyl1z4yausabb5&st=mg53inpu&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.15: Tracking and Logging Applications (2)",
            key: "vi15.2",
            video:
              "https://www.dropbox.com/scl/fi/w2b1ha3lso21t8qwv4nj9/M06MC04-Basic-RNN-Time-series-and-Text-Zoom-1.mp4?rlkey=anbjmargr93p2v7reduoacppr&st=8q2r11u7&raw=1",
            document: [
              {
                title: "Monitoring.pdf",
                link: "https://www.dropbox.com/scl/fi/ufhpyrb070ejboaleniao/Monitoring.pdf?rlkey=spqiwa7suoqqyl1z4yausabb5&st=mg53inpu&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/ufhpyrb070ejboaleniao/Monitoring.pdf?rlkey=spqiwa7suoqqyl1z4yausabb5&st=mg53inpu&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.16: Basic LSTM/GRU (Time-series and Text)",
            key: "vi16",
            video:
              "https://www.dropbox.com/scl/fi/k968ous86nwvt96mys9ok/M06MC06-Basic-LSTM-GRU-Time-series-and-Text-Zoom.mp4?rlkey=5czfb7kstvu0cfdbse1rmsdul&st=nfeqz195&raw=1",
            document: [
              {
                title: "LSTM-GRU[Timeseries and Text]_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/wjngmoo6mz18bdjy6ei0o/LSTM-GRU-Timeseries-and-Text-_v2.pdf?rlkey=rxgxew4so0rr1erhw505dugcg&st=bs0l9h34&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/wjngmoo6mz18bdjy6ei0o/LSTM-GRU-Timeseries-and-Text-_v2.pdf?rlkey=rxgxew4so0rr1erhw505dugcg&st=bs0l9h34&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.17: Tokenization",
            key: "vi17",
            video:
              "https://www.dropbox.com/scl/fi/0qi4mtuvk8bqrs38l9jmu/M06EC07-Tokenization-Zoom.mp4?rlkey=awdt38m78n3wxqheybw15wdj9&st=c9hwz6zd&raw=1",
            document: [
              {
                title: "[Slide] - Tokenization.pdf",
                link: "https://www.dropbox.com/scl/fi/dggce2if5btitgwe136ry/Slide-Tokenization.pdf?rlkey=otmb2g1jjj68s8aii9dspeo1a&st=1ti3vgf1&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/dggce2if5btitgwe136ry/Slide-Tokenization.pdf?rlkey=otmb2g1jjj68s8aii9dspeo1a&st=1ti3vgf1&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.18: TA Exercise week 3",
            key: "vi18",
            video:
              "https://www.dropbox.com/scl/fi/hyzqjw3i6ukon3xm7tnos/M06MC-TA-Exercise-Zoom.mp4?rlkey=0o8obvitohujrep0rxgxzgd94&st=lykne5md&raw=1",
            document: [
              {
                title: "[Slide]_RNN_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/wy6pmz2mpom9u8affm35o/Slide-_RNN_v2.pdf?rlkey=1c0uybytlxiz03yynh3aglyas&st=qcvgqvar&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/wy6pmz2mpom9u8affm35o/Slide-_RNN_v2.pdf?rlkey=1c0uybytlxiz03yynh3aglyas&st=qcvgqvar&dl=1",
                view: true,
              },
              {
                title: "RNN_Description.pdf",
                link: "https://www.dropbox.com/scl/fi/hrtwofc8y0irwrspwrjzh/RNN_Description.pdf?rlkey=juo31ysk8f3og2un4y5g0pyzr&st=9zhgnxuz&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/hrtwofc8y0irwrspwrjzh/RNN_Description.pdf?rlkey=juo31ysk8f3og2un4y5g0pyzr&st=9zhgnxuz&dl=1",
                view: true,
              },
            ],
          },
          // week 4
          {
            title: "WEEK 4 -- Exercise, Document and Study Guide",
            key: "viw4",
            video: " ",
            document: [
              {
                title: "M06W04 - Study Guide.pdf",
                link: "https://www.dropbox.com/scl/fi/5315wsti3vcw54zj7qadw/M06W04-Study-Guide.pdf?rlkey=dapxwk77agpg1h2rqdybib8gi&st=b0kzn24z&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/5315wsti3vcw54zj7qadw/M06W04-Study-Guide.pdf?rlkey=dapxwk77agpg1h2rqdybib8gi&st=b0kzn24z&dl=1",
                view: true,
              },
              {
                title: "[Description]-Transformer-Applications.pdf",
                link: "https://www.dropbox.com/scl/fi/xsbdvntzrbvapzedw4bns/Description-Transformer-Applications.pdf?rlkey=mpm00ze69vgvkp56e4mnwj7rz&st=ovflvxji&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/xsbdvntzrbvapzedw4bns/Description-Transformer-Applications.pdf?rlkey=mpm00ze69vgvkp56e4mnwj7rz&st=ovflvxji&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.19: Vision Transformer",
            key: "vi19",
            video:
              "https://www.dropbox.com/scl/fi/uyyvfdbauuohq4k4i9j2i/M06EC02-Vision-Transformer-Zoom.mp4?rlkey=d9mdjfs0tj071nfqbdx1rivnq&st=askqkkxu&raw=1",
            document: [
              {
                title: "Transformer_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/jgopniwq46nkb56yo6xiq/Transformer_v2.pdf?rlkey=902ky3zsklx4owrtg9wrjz0dh&st=c5dy30w9&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/jgopniwq46nkb56yo6xiq/Transformer_v2.pdf?rlkey=902ky3zsklx4owrtg9wrjz0dh&st=c5dy30w9&dl=1",
                view: true,
              },
              {
                title: "[Solution]_Introduction_to_Transformer.ipynb",
                link: "https://www.dropbox.com/scl/fi/i7tugtfpo1l11qfi9jurr/Solution-_Introduction_to_Transformer.ipynb?rlkey=pw345zbci4g7o5rooady50011&st=1so1oaia&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/i7tugtfpo1l11qfi9jurr/Solution-_Introduction_to_Transformer.ipynb?rlkey=pw345zbci4g7o5rooady50011&st=1so1oaia&dl=1",
                view: false,
              },
            ],
          },
          {
            title: "Lesson 6.20: Transformer (Encoder - Text Classification)",
            key: "vi20",
            video:
              "https://www.dropbox.com/scl/fi/d4y1zno4klk9hbyhqgjiq/M06MC04-Transformer-Encoder-Text-Classification-Zoom.mp4?rlkey=t44qsj5bgfq9e7m2m2r70bga2&st=t2wd7utc&raw=1",
            document: [
              {
                title: "Wednesday_v6.pdf",
                link: "https://www.dropbox.com/scl/fi/fkato0bpmjvtswxprsvr0/Wednesday_v6.pdf?rlkey=qkzk71oi3cba355vveu2vuco3&st=7feg01am&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/fkato0bpmjvtswxprsvr0/Wednesday_v6.pdf?rlkey=qkzk71oi3cba355vveu2vuco3&st=7feg01am&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.21: CI/CD Jenkins (1)",
            key: "vi21.1",
            video:
              "https://www.dropbox.com/scl/fi/ilyt9io89slxiixvslxk8/CI-CD-Zoom.mp4?rlkey=4a41ml7r57ebgrv505hx3oguz&st=zkqw0jpx&raw=1",
            document: [
              {
                title: "CICD_v3.pdf",
                link: "https://www.dropbox.com/scl/fi/gf0ek99sszjkdw6ljzwg6/CICD_v3.pdf?rlkey=mf03lnq12wvl1os5zi1uivgl9&st=skxhlegd&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/gf0ek99sszjkdw6ljzwg6/CICD_v3.pdf?rlkey=mf03lnq12wvl1os5zi1uivgl9&st=skxhlegd&dl=1",
                view: true,
              },
              {
                title: "Demo_CICD_Jenkins.mp4",
                link: "https://www.dropbox.com/scl/fi/z1gsrkdverx9zryjls02l/Demo_CICD_Jenkins.mp4?rlkey=5iep4q8ppqofg7eyn3e75hnxt&st=3nhabagp&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/z1gsrkdverx9zryjls02l/Demo_CICD_Jenkins.mp4?rlkey=5iep4q8ppqofg7eyn3e75hnxt&st=3nhabagp&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.21: CI/CD Jenkins (2)",
            key: "vi21.2",
            video:
              "https://www.dropbox.com/scl/fi/jpgn6q5mkz6x89xitjvko/CI-CD-Zoom-1.mp4?rlkey=tlncq8xvp2sjv9j32tttx4pkx&st=9yhlac8z&raw=1",
            document: [
              {
                title: "CICD_v3.pdf",
                link: "https://www.dropbox.com/scl/fi/gf0ek99sszjkdw6ljzwg6/CICD_v3.pdf?rlkey=mf03lnq12wvl1os5zi1uivgl9&st=skxhlegd&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/gf0ek99sszjkdw6ljzwg6/CICD_v3.pdf?rlkey=mf03lnq12wvl1os5zi1uivgl9&st=skxhlegd&dl=1",
                view: true,
              },
              {
                title: "Demo_CICD_Jenkins.mp4",
                link: "https://www.dropbox.com/scl/fi/z1gsrkdverx9zryjls02l/Demo_CICD_Jenkins.mp4?rlkey=5iep4q8ppqofg7eyn3e75hnxt&st=3nhabagp&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/z1gsrkdverx9zryjls02l/Demo_CICD_Jenkins.mp4?rlkey=5iep4q8ppqofg7eyn3e75hnxt&st=3nhabagp&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.22: Transformer for Image and Time-series Data",
            key: "vi22",
            video:
              "https://www.dropbox.com/scl/fi/girbr14vsoco6cfzqi25b/M06MC06-Transformer-for-Image-and-Time-series-Data-Zoom.mp4?rlkey=shwh7ps3qklu7hitz6uvskc6i&st=v8ncm95m&raw=1",
            document: [
              {
                title: "Reading_Transformer.pdf",
                link: "https://www.dropbox.com/scl/fi/9rv3iwb0641tydomvis3f/Reading_Transformer.pdf?rlkey=7x3xe97w4hcnat2r7vqqtp866&st=zj6wnpum&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/9rv3iwb0641tydomvis3f/Reading_Transformer.pdf?rlkey=7x3xe97w4hcnat2r7vqqtp866&st=zj6wnpum&dl=1",
                view: true,
              },
              {
                title: "Transformer_Insight_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/i9fi81uftac4aedmky9dl/Transformer_Insight_v2.pdf?rlkey=l4nspb9xuivte3xzxgegw10fn&st=4d6jq442&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/i9fi81uftac4aedmky9dl/Transformer_Insight_v2.pdf?rlkey=l4nspb9xuivte3xzxgegw10fn&st=4d6jq442&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.23: Embedding",
            key: "vi23",
            video:
              "https://www.dropbox.com/scl/fi/lo1qpvvlshy1o21m05z5u/M06EC07-Embedding-Zoom.mp4?rlkey=dlaf5sbhdi8j13dbnnqdjo1v8&st=7b94k99b&raw=1",
            document: [
              {
                title: "[Report]-Embedding.pdf",
                link: "https://www.dropbox.com/scl/fi/ptyw7zg26vzyhtywz73i8/Report-Embedding.pdf?rlkey=73dztdlahsqvq9kl4oodtvx13&st=9xvdud4z&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/ptyw7zg26vzyhtywz73i8/Report-Embedding.pdf?rlkey=73dztdlahsqvq9kl4oodtvx13&st=9xvdud4z&dl=1",
                view: true,
              },
              {
                title: "[Slide]-Embedding_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/3wcw2e8zwufbq9qgf7ta3/Slide-Embedding_v2.pdf?rlkey=dkc1azum98yjnlzo6czl9wpgc&st=eed4estj&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/3wcw2e8zwufbq9qgf7ta3/Slide-Embedding_v2.pdf?rlkey=dkc1azum98yjnlzo6czl9wpgc&st=eed4estj&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.24: TA Exercise week 4",
            key: "vi24",
            video:
              "https://www.dropbox.com/scl/fi/fmojwxvy6f5r8lfi6z7jf/M06MC-TA-Exercise-Zoom.mp4?rlkey=wrqs81qyqxmz2a1w1hbqg74ra&st=3enugmgt&raw=1",
            document: [
              {
                title: "[Description]-Transformer-Applications.pdf",
                link: "https://www.dropbox.com/scl/fi/xsbdvntzrbvapzedw4bns/Description-Transformer-Applications.pdf?rlkey=mpm00ze69vgvkp56e4mnwj7rz&st=6hn972b9&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/xsbdvntzrbvapzedw4bns/Description-Transformer-Applications.pdf?rlkey=mpm00ze69vgvkp56e4mnwj7rz&st=6hn972b9&dl=1",
                view: true,
              },
              {
                title: "[Slide]-Transformer.pdf",
                link: "https://www.dropbox.com/scl/fi/v1sj6gjcsdbu5jyxrm4sg/Slide-Transformer.pdf?rlkey=xmcg0g9mfewr8ty67ab1bei59&st=n1e6km5n&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/v1sj6gjcsdbu5jyxrm4sg/Slide-Transformer.pdf?rlkey=xmcg0g9mfewr8ty67ab1bei59&st=n1e6km5n&dl=1",
                view: true,
              },
            ],
          },
          // week 5
          {
            title: "WEEK 5 -- Exercise, Document and Study Guide",
            key: "viw5",
            video: " ",
            document: [
              {
                title: "M06W05 - Study Guide.pdf",
                link: "https://www.dropbox.com/scl/fi/m3qmnp9u0k9eu4uennse2/M06W05-Study-Guide.pdf?rlkey=zhemr74435vl9ulw3e93x1um5&st=onxtzira&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/m3qmnp9u0k9eu4uennse2/M06W05-Study-Guide.pdf?rlkey=zhemr74435vl9ulw3e93x1um5&st=onxtzira&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.25: Image Project: OCR (Yolov11+CNN)",
            key: "vi25",
            video:
              "https://www.dropbox.com/scl/fi/ghfw593d4xdlln98csing/M06MC-Image-Project-OCR-Yolov11-CNN-Zoom.mp4?rlkey=pq98bgi38x17zsh4ki4oknxqx&st=u02f5rv7&raw=1",
            document: [
              {
                title: "Description.pdf",
                link: "https://www.dropbox.com/scl/fi/0uhqsvgcvni5hzb8dnqtl/Description.pdf?rlkey=5o2a8j119a0q9v8m2g9k75ziz&st=lvigq76n&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/0uhqsvgcvni5hzb8dnqtl/Description.pdf?rlkey=5o2a8j119a0q9v8m2g9k75ziz&st=lvigq76n&dl=1",
                view: true,
              },
              {
                title: "[Slide]-OCR Project_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/01dfk4eahaqb0f9s1g97m/Slide-OCR-Project_v2.pdf?rlkey=8ihicadem5whtxddgrfx9ae3n&st=1cqea8aq&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/01dfk4eahaqb0f9s1g97m/Slide-OCR-Project_v2.pdf?rlkey=8ihicadem5whtxddgrfx9ae3n&st=1cqea8aq&dl=1",
                view: true,
              },
              {
                title: "demo-fastapi-ray-serve.mp4",
                link: "https://www.dropbox.com/scl/fi/pynlmmk7x19h4sa4f71sv/demo-fastapi-ray-serve.mp4?rlkey=z9714o9uvm8mr6xsxs4sal0rw&st=igpxp5l1&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/pynlmmk7x19h4sa4f71sv/demo-fastapi-ray-serve.mp4?rlkey=z9714o9uvm8mr6xsxs4sal0rw&st=igpxp5l1&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 6.26: Image&Text Project: VQA",
            key: "vi26",
            video:
              "https://www.dropbox.com/scl/fi/q1b2s7370vkltfr6d5f2m/M06MC-Image-Text-Project-VQA-Zoom.mp4?rlkey=0meio7o6n60dlxtf9u1pu4uaf&st=b8wtv894&raw=1",
            document: [
              {
                title:
                  "Documents_2025-0_VQA Project_[Slide]-VQA-Project_v2.pdf",
                link: "https://www.dropbox.com/scl/fi/1nmv0stbtzkta8ptyp12b/Documents_2025-0_VQA-Project_-Slide-VQA-Project_v2.pdf?rlkey=qa3nocgd3yefll6nqno1e7z09&st=cv01c8zw&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/1nmv0stbtzkta8ptyp12b/Documents_2025-0_VQA-Project_-Slide-VQA-Project_v2.pdf?rlkey=qa3nocgd3yefll6nqno1e7z09&st=cv01c8zw&dl=1",
                view: true,
              },
              {
                title:
                  "Documents_2025-0_VQA Project_[Description]_Project_VQA.pdf",
                link: "https://www.dropbox.com/scl/fi/dng9j5f2qgn0pn6p1pyqm/Documents_2025-0_VQA-Project_-Description-_Project_VQA.pdf?rlkey=skrwscj42x0w6kko4en9x0rnx&st=q3yymlxg&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/dng9j5f2qgn0pn6p1pyqm/Documents_2025-0_VQA-Project_-Description-_Project_VQA.pdf?rlkey=skrwscj42x0w6kko4en9x0rnx&st=q3yymlxg&dl=1",
                view: true,
              },
            ],
          },

          // {
          //   title: "",
          //   key: "vi",
          //   video: " ",
          //   document: [
          //     {
          //       title: "",
          //       link: "",
          //       linkDownload: "",
          //       view: true,
          //     },
          //   ],
          // },
        ],
      },
      Module7: {
        title: "Module 7: Deep Learning for Image",
        children: [
          {
            title: "WEEK 1 -- Exercise, Document and Study Guide",
            key: "xii7",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7.1: UNet",
            key: "l7.1",
            video: "https://www.dropbox.com/scl/fi/bovvrnvdcufzw98cun2x2/M07EC03-UNet-Zoom.mp4?rlkey=5gonh5l9oa2nldmroqxtdarhq&st=urghpfwv&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7.2: Transfer Learning",
            key: "l7.2",
            video: "https://www.dropbox.com/scl/fi/h1yfecp7h6jyj9zigohzw/M07MC04-Transfer-Learning-Zoom.mp4?rlkey=5jlfprdkqxpvqdihndw4t3u35&st=nowxpc0u&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7.3: Model Compression and Evaluation",
            key: "l7.3",
            video: "https://www.dropbox.com/scl/fi/15kgt8wlsolfcoirn6p9e/M07EC05-Model-Compression-and-Evaluation-Zoom.mp4?rlkey=7ht5q7x7nl9l8ulqdwiv2e7yp&st=qw9wruqb&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7.4: Domain Conversion - Segmentation",
            key: "l7.4",
            video: "https://www.dropbox.com/scl/fi/kyq70bv6ll5ovi35zy4uy/M07MC06-Domain-Conversion-Segmentation-Zoom.mp4?rlkey=y96nj9cmn6y97s5t29w0nrwna&st=fztha5ga&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7.5: Knowledge Distillation (1)",
            key: "l7.5",
            video: "https://www.dropbox.com/scl/fi/butfbzchs5e78t8qco042/M07EC07-Knowledge-Distillation-1-Zoom.mp4?rlkey=tl03pdqb0zygo8qf5ynxpuld1&st=2zt66lqu&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7.6: TA-Exercise",
            key: "l7.6",
            video: "https://www.dropbox.com/scl/fi/cbqje8camlqjp6og2p4c8/M07MC-TA-Exercise-Zoom.mp4?rlkey=iphxqr716s0w67fvgd5tb5tn5&st=sxnfllog&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          // w2
          {
            title: "WEEK 2 -- Exercise, Document and Study Guide",
            key: "vii2",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7.7: Object Detection Using Pretrained Models",
            key: "l7.7",
            video: "https://www.dropbox.com/scl/fi/hujvmigylsvaeeh8j0k3y/M07EC03-Introduction-to-Object-Detection-Zoom.mp4?rlkey=q0l896k0pjtp16ifeucvlrc97&st=hhtauye0&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7.8: Object Detection",
            key: "l7.8",
            video: "https://www.dropbox.com/scl/fi/2ul6v9i6yfr14zk3h1mkp/M07MC04-Object-Detection-Zoom.mp4?rlkey=rdjkoind8cwv71haczf8ql97b&st=agrt6pgu&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7.9: Model Quantization",
            key: "l7.9",
            video: "https://www.dropbox.com/scl/fi/tbqd5cz6c203gewh0j2et/M07EC05-Model-Quantization-Zoom.mp4?rlkey=84mipn5ygm76fq922la1qmitt&st=0ejw4h1d&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7.10: Object Detection",
            key: "l7.10",
            video: "https://www.dropbox.com/scl/fi/t9oqrda6pakkk8489ngs6/M07MC06-Object-Detection-Zoom.mp4?rlkey=cunntb997qxijn2n94vcizb3c&st=ycmhi62x&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7.11: Knowledge Distillation (2)",
            key: "l7.11",
            video: "https://www.dropbox.com/scl/fi/4d9toyu3azldhi5vbuvqt/M07EC07-Knowledge-Distillation-2-Zoom.mp4?rlkey=c55r1d2j20h7suhaw7y56t608&st=vxstl70i&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7.12: TA-Exercise",
            key: "l7.12",
            video: "https://www.dropbox.com/scl/fi/ec7air4w9polii4zlyd2w/M07MC-TA-Exercise-Zoom.mp4?rlkey=ioik5iqebb7zxyqh0f75w8z41&st=8ultjgx6&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          // w3
          {
            title: "WEEK 3 -- Exercise, Document and Study Guide",
            key: "vii3",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7.13: Yolov1",
            key: "l7.13",
            video: "https://www.dropbox.com/scl/fi/r2shr065k9kwyqwoectv7/M07EC03-Yolov1-Zoom.mp4?rlkey=qhaltnn8ahh26kdp72k116d6e&st=4yh49vv1&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7.14: Object Detection",
            key: "l7.14",
            video: "https://www.dropbox.com/scl/fi/hsoah8acf7myfnr775elo/M07MC-Object-Detection-Zoom.mp4?rlkey=ilk6msbtw6am74heker22yte2&st=rkf62tci&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7.15: Model Pruning",
            key: "l7.15",
            video: "https://www.dropbox.com/scl/fi/p2lavzfbic527rrp6ffz9/Model-Pruning.mp4?rlkey=xewmgiuqicwt7b6afj6vvvp9j&st=8m0h9zsv&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7.16: Object Detection",
            key: "l7.16",
            video: "https://www.dropbox.com/scl/fi/4b54w8hcxqq29tuu4kum0/M07MC-Object-Detection-Zoom-1.mp4?rlkey=0b4dz8u86up46o0ew1o78boxo&st=dtax2s7v&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7.17: Data Augmentation",
            key: "l7.17",
            video: "https://www.dropbox.com/scl/fi/0kfx1qnadvtgpopshe6qo/M07EC07-Data-Augmentation-Zoom.mp4?rlkey=aa8tg3aa05gkpoqug02vkj24k&st=9osdzulh&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7.18: TA-Exercise",
            key: "l7.18",
            video: "https://www.dropbox.com/scl/fi/4sp0pkhtrdwj5nz0n1lxx/M07MC-TA-Exercise-Zoom.mp4?rlkey=5po69apf6dnc4v23gjoob1x6w&st=016efkd2&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
        ],
      },
      Module8: {
        title: "Module 8: Deep Learning for Text",
        children: [
          {
            title: "WEEK 1 -- Exercise, Document and Study Guide",
            key: "m8w1",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 8.1:Introduction to Text Classification and POS Tagging",
            key: "m8l1",
            video: "https://www.dropbox.com/scl/fi/m5qfpwdgm4bfxyiynkrkn/M08EC-Introduction-to-Text-Classification-and-POS-Tagging-Zoom.mp4?rlkey=xyftzarngxbkvvckh0an5yx46&st=8dgg82o2&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 8.2: From Text Classification to POS Tagging",
            key: "m8l2",
            video: "https://www.dropbox.com/scl/fi/82uc6sec13gmsskiemly0/M08MC-From-Text-Classification-to-POS-Tagging-Zoom.mp4?rlkey=quuqpt2kk0qwmcf5afj18j9v2&st=iuoj3e6v&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 8.3: Medical Image Analysis",
            key: "m8l3",
            video: "https://www.dropbox.com/scl/fi/o2mus4gfsaauv18x3xips/M08EC-Medical-Image-Analysis-Zoom.mp4?rlkey=a8gnpurat9488ljpyh6243e31&st=p4e8cyyx&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 8.4: NER for Medical Data",
            key: "m8l4",
            video: "https://www.dropbox.com/scl/fi/nv22eyzjx9cp5blvwx37p/M08MC-NER-for-Medical-Data-Zoom.mp4?rlkey=5acd1zjefg62c4ia1mazgj6di&st=wd20q9ej&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 8.5: Mixture of Experts",
            key: "m8l5",
            video: "https://www.dropbox.com/scl/fi/eocikqhd4o57if5b4k111/M08EC-Mixture-of-Experts-Zoom.mp4?rlkey=xf9qi26huys8z1ki6bfhhydt7&st=xtall40m&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 8.6: TA-Exercise",
            key: "m8l6",
            video: "https://www.dropbox.com/scl/fi/jx6n1bqt5lxepc5ewmj20/M08MC-TA-Exercise-Zoom.mp4?rlkey=i6xthece4jjwn39u9y4758wqa&st=x5ocuk50&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 2 -- Exercise, Document and Study Guide",
            key: "m8w2",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 8.7: Introduction to NER and QA",
            key: "m8l7",
            video: "https://www.dropbox.com/scl/fi/eqkrnnsv0i42hvixaf51z/M08W02-Introduction-to-NER-and-QA-Zoom.mp4?rlkey=4mzntms2506emfziyxmqinm7g&st=vsw0367d&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 8.8: Project: Aspect Extraction and Content Classification (Text Classification + NER)",
            key: "m8l8",
            video: "https://www.dropbox.com/scl/fi/mz9c8kkmptrb7ft4rljkv/M08MC-Project-Aspect-Extraction-and-Content-Classification-Text-Classification-NER-Zoom.mp4?rlkey=uo8iqs36q3lfze1r8wtn4wr8c&st=a1ighrax&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 8.9: Face Detection and Identification",
            key: "m8l9",
            video: "https://www.dropbox.com/scl/fi/bo1c66ezsl7rdbd6nsf9y/M08W02-Face-Detection-and-Identification-Zoom.mp4?rlkey=f9afblsm1ve3u0l1dpt4oswmi&st=geqb1by1&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 8.10: Project: QA for Content Inquiry (~ Text Classification and NER)",
            key: "m8l10",
            video: "https://www.dropbox.com/scl/fi/t0oda1bob9ckcw1usnxcy/_M08W02-Project-QA-for-Content-Inquiry-.-Text-Classification-and-NER-Zoom.mp4?rlkey=lkpu5i3ieuw9cusphr98y7os7&st=gl61vqtp&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 8.11: Project: End-to-end Question Answering (Building Searching Tool)",
            key: "m8l11",
            video: "https://www.dropbox.com/scl/fi/cusu2dcfx1745jcc7ib45/M08MC-Project-End-to-end-Question-Answering-Building-Searching-Tool-Zoom.mp4?rlkey=0hfx4kzyrifdn50nb33gv2uj0&st=vm5mvven&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 3 -- Exercise, Document and Study Guide",
            key: "m8w3",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 8.12: Introduction to Text Generation & Machine Translation",
            key: "m8l12",
            video: "https://www.dropbox.com/scl/fi/aae5b3w9ybo7qijwqsi97/M08W03-Intro-to-Text-Generation-and-Translation-Zoom.mp4?rlkey=5jaeua2ob7r8696pnn1qupsca&st=9ok50erw&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 8.13: Text Generation",
            key: "m8l13",
            video: "https://www.dropbox.com/scl/fi/n8p7yzyl8w1bbugvhtvs7/M08W03-Text-Generation-Zoom.mp4?rlkey=gq9gjbxnqdmge7b6h9xua051c&st=qvhy1pn5&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 8.14: Vehicle counting using YOLOv10 and Bytetrack (multiple object tracking and counting)",
            key: "m8l14",
            video: "https://www.dropbox.com/scl/fi/dgfvq0gkqfm0ponngc3e3/M08W03-Vehicle-counting-using-YOLOv10-and-Bytetrack-multiple-object-tracking-and-counting-Zoom.mp4?rlkey=ui3zikaum1d0y88dm2ryiufqa&st=cxqeqpu0&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 8.15: Machine Translation",
            key: "m8l15",
            video: "https://www.dropbox.com/scl/fi/8zxlu3uxiv9a1ax45qyby/M08W03-Machine-Translation-Zoom.mp4?rlkey=c6v46gegpm04i904cz7gdibxl&st=vl2ihche&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 8.16: KAN Model",
            key: "m8l16",
            video: "https://www.dropbox.com/scl/fi/kz7k4iyk5p42g8sj6f6e7/M08W03-KAN-Model-Zoom.mp4?rlkey=h1qm118sc2n93dk9qvivvxp1a&st=w18xc6bx&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 8.17: TA-Exercise",
            key: "m8l17",
            video: "https://www.dropbox.com/scl/fi/k4btsgo4zqulkm6f3qpno/M08W03-TA-Exercise-Zoom.mp4?rlkey=3ui7r1ek20zgkqhb7vk2qs1n3&st=nptw5w43&raw=1",
            document: [
              
            ],
          },         
          {
            title: "WEEK 4 -- Exercise, Document and Study Guide",
            key: "m8w4",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 8.18: Text Project: VN-EN Language Translation",
            key: "m8l18",
            video: "https://www.dropbox.com/scl/fi/mf5zc0r0y32ee56b8nfw1/M08W04-Text-Project-VN-EN-Language-Translation-Zoom.mp4?rlkey=ezpi1ymvojlr5mo3rv6kov6ho&st=9lw85zzh&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 8.19: Text Project: Poem Generation",
            key: "m8l19",
            video: "https://www.dropbox.com/scl/fi/wid5cqxkpkh2hcj5s043o/M08W04-Text-Project-Poem-Generation-Zoom.mp4?rlkey=n3o9hjc5lvyfayr3xpwb849v6&st=w8q2e5i3&raw=1",
            document: [
              
            ],
          },
        ],
      },
      Module9: {
        title: "Module 9: Generative Models",
        children: [
          {
            title: "WEEK 1 -- Exercise, Document and Study Guide",
            key: "m9w1",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 9.1: Basic Style Transfer",
            key: "m9l1",
            video: "https://www.dropbox.com/scl/fi/1zmu0z6jr39lubv73gw10/M09-W01-Basic-Style-Transfer-Zoom.mp4?rlkey=ac1iy4su7zpaevttuueqpeltu&st=7jw56nlq&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.2 Basic Style Transfer (main)",
            key: "m9l2",
            video: "https://www.dropbox.com/scl/fi/qp5xsvwpr6ttwf9idky73/M09W01MC-Basic-Style-Transfer-Zoom.mp4?rlkey=q3qdzqbk18540l0rzw4rpzjww&st=eh3umug5&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.3 Domain Adaptation",
            key: "m9l3",
            video: "https://www.dropbox.com/scl/fi/hchl6dc1c6fcq1kci75ks/M09W01EC-Domain-Adaptation-Zoom.mp4?rlkey=9hjjrzc5fuweeoy7xouh5ke1y&st=76p9e6qx&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.4 Multi-modal Style Transfer",
            key: "m9l4",
            video: "https://www.dropbox.com/scl/fi/gp6y9xjsapcd3tws9bqlk/M09W01MC-Multi-modal-Style-Transfer-Zoom.mp4?rlkey=3nu967xjrirnebr4b91bgpizz&st=82yio4qh&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.5 Transformer and its Extentions",
            key: "m9l5",
            video: "https://www.dropbox.com/scl/fi/yoi3iw8k9ilk91wvqfbmj/M09EC07-Transformer-and-its-Extentions-Zoom.mp4?rlkey=tt74p4hl379ifha54bfdrcko4&st=vpu9fqs0&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.6: TA-Exercise",
            key: "m9l6",
            video: "https://www.dropbox.com/scl/fi/oqu19tw12x2yk7dpgyc97/TA-ExerciseW1.mp4?rlkey=sjxgn3za9zxsjg12tyz1fbyw3&st=1coya8pd&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 2 -- Exercise, Document and Study Guide",
            key: "m9w2",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 9.7: DCGAN",
            key: "m9l7",
            video: "https://www.dropbox.com/scl/fi/2xhoh3g1kdfwj3jwhrism/M09W02-DCGAN-Zoom.mp4?rlkey=t78hbdhmrrdyq27a7qwjmbgka&st=83h3eeqe&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.8: GAN and DCGAN",
            key: "m9l8",
            video: "https://www.dropbox.com/scl/fi/trnho9bnnj0u8g2msq760/M09W02-GAN-and-DCGAN-Zoom.mp4?rlkey=dhm197duaofpmqgytjwlkay9i&st=z0wqimqx&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.9: DeepSeek",
            key: "m9l9",
            video: "https://www.dropbox.com/scl/fi/45ljrjn83hq3daohgqesk/M09W02-DeepSeek-Zoom.mp4?rlkey=wqz5oi4070mbjapzyu2lucmbr&st=dzbvsr9n&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.10: Pix2Pix and Cycle GAN",
            key: "m9l10",
            video: "https://www.dropbox.com/scl/fi/mxd9219tl6ul39ab7sr5f/M09W02-Pix2Pix-and-Cycle-GAN-Zoom.mp4?rlkey=b0h89mo6i88wmd02yauv3o7gj&st=bqji9hje&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.11: YOLOv1-v12",
            key: "m9l11",
            video: "https://www.dropbox.com/scl/fi/1dkbxhscfogsng4yz2yv9/M09W02-YOLOv1-v12-Zoom.mp4?rlkey=6eubjxtdz4gizmiva1i9zy5f3&st=1bhl6ejd&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.12: TA-Exercise",
            key: "m9l12",
            video: "https://www.dropbox.com/scl/fi/5mumjyjltya8mt6yq3hlt/M09W02-TA-Exercise-Zoom.mp4?rlkey=qb5mar15b2l70kd27egnpcilq&st=3gcn1skw&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 3 -- Exercise, Document and Study Guide",
            key: "m9w3",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 9.13: VAE",
            key: "m9l13",
            video: "https://www.dropbox.com/scl/fi/mf8opglcin3xngto9c5k9/M09W03-VAE-for-Image-Generation-Zoom.mp4?rlkey=deja73ehlhr5yo6ltii0ahfeq&st=udkh68lb&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.14: Project VAE-Based Image Colorization",
            key: "m9l14",
            video: "https://www.dropbox.com/scl/fi/b7et49j0impxq20aqwc5j/M09W03-Project-VAE-Based-Image-Colorization-Zoom.mp4?rlkey=bipmp6pufqea5fc7s7n691iux&st=01hdrngo&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.15: MLOps for Project (1)",
            key: "m9l15",
            video: "https://www.dropbox.com/scl/fi/bgwpzng9mohbyab54xkvb/M09W03-Project-2-MLOps-for-Project-1-Zoom.mp4?rlkey=cedbb70ff52q7d3rbie51rj9k&st=q7545r6q&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 4 -- Exercise, Document and Study Guide",
            key: "m9w4",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 9.16: Diffusion Models",
            key: "m9l16",
            video: "https://www.dropbox.com/scl/fi/g0i3ju0jcad72zxsbfeyy/M09W04-Diffusion-Models-Zoom.mp4?rlkey=097xodwktccegu72zdq0jww2f&st=ky4hehqg&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.16: Diffusion Models (main 1)",
            key: "m9l16",
            video: "https://www.dropbox.com/scl/fi/xstnexe2ocr4msb0a1s59/M09W04MC-Diffusion-Models-Zoom.mp4?rlkey=kyks7ru2elm5les1nbs5kmjv5&st=b9mrla4p&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload:"",
                view: false,
              },
            ],
          },
          {
            title: "Lesson 9.17: Unsupervised Leaning",
            key: "m9l17",
            video: "https://www.dropbox.com/scl/fi/mpx3kn7q5brd4mbi9ss2x/M09W04-Unsupervised-Leaning-Zoom.mp4?rlkey=d8mn8zdny1mwe6yh9teich7ru&st=9wxw4w4d&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload:"",
                view: false,
              },
            ],
          },
          {
            title: "Lesson 9.18: Stable Diffusion (main 2)",
            key: "m9l18",
            video: "https://www.dropbox.com/scl/fi/5sd3y5kuwugfv1n9za8eu/M09W04MC-Stable-Diffusion-Zoom.mp4?rlkey=evjw72zhe35jfi4vgcbgocapk&st=m4ts21s9&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload:"",
                view: false,
              },
            ],
          },
          {
            title: "Lesson 9.19: CLIP for Image Classification",
            key: "m9l19",
            video: "https://www.dropbox.com/scl/fi/s3zivoynylypq49xr87f2/M09W04EC-for-Image-Classification-Zoom.mp4?rlkey=65c8c5q1iy4zn3xhj4nweqp40&st=61m7g1f4&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload:"",
                view: false,
              },
            ],
          },
          {
            title: "Lesson 9.20: TA-Exercise",
            key: "m9l20",
            video: "https://www.dropbox.com/scl/fi/h8cj5ovrx649bifuvtd24/M09W04MC-TA-Exercise-Zoom.mp4?rlkey=1f7nafusc2ay7z943zfrle7bd&st=yn35pvd9&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload:"",
                view: false,
              },
            ],
          },
          {
            title: "WEEK 5 -- Exercise, Document and Study Guide",
            key: "m9w5",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 9.21: Flow Matching",
            key: "m9l21",
            video: "https://www.dropbox.com/scl/fi/by6t6xd4s6nrmf54qgk97/M09W05EC-Flow-Matching-Zoom.mp4?rlkey=h17kp7lu0k5l53zsrtxuwv74n&st=4dc02ktl&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.22: Flow Matching (main 1)",
            key: "m9l22",
            video: "https://www.dropbox.com/scl/fi/5az41va83frt7bwg0r791/M09W05MC-Flow-Matching-1-Zoom.mp4?rlkey=qo5n4e0672bu6dlg8neq14791&st=lqkttbgq&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.23: Flow Matching (main 2)",
            key: "m9l23",
            video: "https://www.dropbox.com/scl/fi/xpogndov124rosoz2jkbe/M09W05MC-v2-Flow-Matching-2-Zoom.mp4?rlkey=wgnjmebljor668t2y3pkc15zd&st=xrgp9uxk&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.24: VideoCLIP for Video Classification",
            key: "m9l24",
            video: "https://www.dropbox.com/scl/fi/m0r2a6bulq2w9yjshtbn7/M09W05EC-for-Classification-Zoom.mp4?rlkey=hh1hc91cafnnbau36ky2nsuh1&st=wmze8xp4&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.25: TA-Exercise",
            key: "m9l25",
            video: "https://www.dropbox.com/scl/fi/g1hfqs0fcabxtrfi0m2hz/M09W05-TA-Exercise-Zoom.mp4?rlkey=kh7zcln70nl6pqx306by4tm2b&st=i38drw5y&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload:"",
                view: false,
              },
            ],
          },
          {
            title: "WEEK 6 -- Exercise, Document and Study Guide",
            key: "m9w6",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 9.26: Project Diffusion-based Image Colorization",
            key: "m9l26",
            video: "https://www.dropbox.com/scl/fi/zpyt89cnwllzxd3agmwsg/M09W06-Project-1-Diffusion-based-Image-Colorization-Zoom.mp4?rlkey=hg2wza3ucqgihaxlds558vm7u&st=xwkbdt38&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.27: Project FM-based Image Generation",
            key: "m9l27",
            video: "https://www.dropbox.com/scl/fi/0yyffrkas2cqf7jsp6cgf/M09W06-Project-2-FM-based-Image-Generation-Zoom.mp4?rlkey=n116r2cloblcrsn96mctepg7z&st=poskm34t&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 9.28: MLOps for Project (2) and (3)",
            key: "m9l28",
            video: "https://www.dropbox.com/scl/fi/91mpvmm1ymv5uoj9q1i9d/M09W06-Project-3-Scaling-with-Docker-Swarm-and-Kubernetes-Zoom.mp4?rlkey=7b6ixw8hgojtgivpgf0gkxiai&st=a8nzqmh3&raw=1",
            document: [
              
            ],
          },

        ],
      },
      Module10: {
        title: "Module 10: Advanced Deep Learning",
        children: [
          {
            title: "WEEK 1 -- Exercise, Document and Study Guide",
            key: "m10w1",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 10.1: Pretraining LLM (GPT)",
            key: "m10l1",
            video: "https://www.dropbox.com/scl/fi/zohlwmfzvfttl9w08zb6r/M10W01_Pretraining-LLM-GPT-Zoom.mp4?rlkey=2g63suvf8b2lahsohe8ujda6h&st=n053q3gn&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 10.2: GNN (Node Classification)",
            key: "m10l2",
            video: "https://www.dropbox.com/scl/fi/r366dh06gp7kff15sw1qu/M10W01_-v2-GNN-Node-Classification-Zoom.mp4?rlkey=oijg24j662qkwwv9m8tetexcj&st=z9ybx3w0&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 10.3: RAG, Prompting and LangChain",
            key: "m10l3",
            video: "https://www.dropbox.com/scl/fi/q4idte5ye8mb8mjifk0fd/M10W01-RAG-Prompting-and-LangChain-Zoom.mp4?rlkey=7s73gbvacfd0ydeddnwf23n4k&st=tp0dr5yj&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 10.4: GNN (Molecular Property Prediction)",
            key: "m10l4",
            video: "https://www.dropbox.com/scl/fi/hooea40fddxrg2gjr4fan/M10W01-GNN-Molecular-Property-Prediction-Zoom.mp4?rlkey=mkbri9e6881crtrt8glo7t4ak&st=f73fvjs7&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 10.5: Parameter-Efficient Fine-Tuning (Lora, Qlora)",
            key: "m10l5",
            video: "https://www.dropbox.com/scl/fi/ihmfk9byrjovhd89dgbqk/M10W01-Parameter-Efficient-Fine-Tuning-Lora-Qlora-Zoom.mp4?rlkey=hyc4fr47y3jku8vu0lexplg74&st=nxl7kmww&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 2 -- Exercise, Document and Study Guide",
            key: "m10w2",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 10.6: Instruction tuning (prompt for training)",
            key: "m10l6",
            video: "https://www.dropbox.com/scl/fi/8mfaaan60bwszq0mmx3kf/M10W02-Instruction-Tuning-Zoom.mp4?rlkey=om9nnvz2w72yai3h3geyni4wq&st=0hd266wk&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 10.7: XAI Lime",
            key: "m10l7",
            video: "https://www.dropbox.com/scl/fi/0gqf4k9epzuu4yc4t8tu1/M10W02-XAI-_-LIME-Method-Zoom.mp4?rlkey=0dx22h39fo05w7l18r6hxi5fi&st=loqslmw6&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 10.8: Project 1 PEFT for Multuiple-choice QA",
            key: "m10l8",
            video: "https://www.dropbox.com/scl/fi/b0x466gang8nwq825mpsa/M10W02-Project-1-PEFT-for-Multiple-choice-QA-Zoom.mp4?rlkey=dl4e7chga95puta4mz3tfx10s&st=zqskncv3&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 10.9: XAI Anchor (t-test)",
            key: "m10l9",
            video: "https://www.dropbox.com/scl/fi/z6nxoo24o9f23qjagc7aj/M10W02-XAI_ANCHOR-Zoom.mp4?rlkey=vsiycgtx3qhyf0o4m5i1b9jn2&st=xdu8iyi5&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 10.10: LLMOps for Project 2",
            key: "m10l10",
            video: "https://www.dropbox.com/scl/fi/0zqgbgj1jiyhwka11ys8t/M10W02-Project-2-LLMOps-for-Project-1-Zoom.mp4?rlkey=6jqn7vx961zky41j271xyojyi&st=vp9njuqq&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 3 -- Exercise, Document and Study Guide",
            key: "m10w3",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 10.11: LLM Reasoning Chain of Thought & DeepSeek Model",
            key: "m10l11",
            video: "https://www.dropbox.com/scl/fi/8ktlpjphb45uc337n6xfv/M10W03-LLM-Reasoning-Zoom.mp4?rlkey=5rt1vocq59w5xghkfy5vk83xe&st=38toqnnw&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 10.12: Enhancing LLMs with Reinforcement Learning (RLHF, DPO)",
            key: "m10l12",
            video: "https://www.dropbox.com/scl/fi/w53y201svwiajbhsy2hck/M10W03-Preference-Tuning-Zoom.mp4?rlkey=ddrtbrtbiejwgvld0vdjj12h1&st=bmr30z4m&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 4 -- Exercise, Document and Study Guide",
            key: "m10w4",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 10.13: Classification for 3D Point Cloud Data",
            key: "m10l13",
            video: "https://www.dropbox.com/scl/fi/89ginmqcsssgbky21u5zd/M10W04-Classification-for-3D-Point-Cloud-Data-Zoom.mp4?rlkey=3412r95liazxxkpf5yt1ctcf0&st=np9gopmv&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 10.14: Project 3 Chatbot Using LLMs",
            key: "m10l14",
            video: "https://www.dropbox.com/scl/fi/k6hk3p8p7v19lp4j2cb5p/M10W04-Project-3-Chatbot-Using-LLMs-Zoom.mp4?rlkey=fh8cn6rwodnbuq2iomrc2420q&st=81k6t1m0&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 10.15: Advances in 3D Point Cloud Data",
            key: "m10l15",
            video: "https://www.dropbox.com/scl/fi/2k5auwacirn9lkpj2qpt2/M10W04-Advances-in-3D-Point-Cloud-Data-updated-Zoom.mp4?rlkey=s2fbzf9mex6nroix3cc6ss1d0&st=fm2hq4id&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 10.16: AI Agents with LLMs: Using Libraries",
            key: "m10l16",
            video: "https://www.dropbox.com/scl/fi/wjhba7vitrlqjmcykf64t/M10W04-AI-Agents-with-LLMs-Using-Libraries-Zoom.mp4?rlkey=oxevanj1nc91zesik0qoyf83m&st=vksytmj5&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 10.17: AI Agents with LLMs: Using Tool Callings",
            key: "m10l17",
            video: "https://www.dropbox.com/scl/fi/vfrdt6swc5p7q0ultnywf/M10W04-AI-Agents-with-LLMs-Using-Tool-Callings-Zoom.mp4?rlkey=p3180w9s2eur5iscsrhub2dxj&st=jfpdqwhr&raw=1",
            document: [
              
            ],
          },
          {
            title: "WEEK 5 -- Exercise, Document and Study Guide",
            key: "m10w5",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 10.18: Reinforcement Learning (CartPole)",
            key: "m10l18",
            video: "https://www.dropbox.com/scl/fi/x2ek9ny3w7086cw4tyo3x/M10W05-Reinforcement-Learning-CartPole-Zoom.mp4?rlkey=a1s1tcg9sdxhl1fp12f70dun5&st=g1huzsyc&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload:"",
                view: false,
              },
            ],
          },
          {
            title: "Lesson 10.19: AI Agents with LLMs: ReAct Agents",
            key: "m10l19",
            video: "https://www.dropbox.com/scl/fi/o8jtlfzk4x0u667cxyx3e/M10W05-AI-Agents-with-LLMs-ReAct-Agents-Zoom.mp4?rlkey=7lheet8maw826de105hy0h21m&st=5r3aobj9&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload:"",
                view: false,
              },
            ],
          },
          {
            title: "Lesson 10.20: Reinforcement Learning (Deep Deterministic Policy Gradient) (1)",
            key: "m10l20",
            video: "https://www.dropbox.com/scl/fi/kqzunalj3pks97pual5mz/M10W05-Reinforcement-Learning-Deep-Deterministic-Policy-Gradient-Zoom.mp4?rlkey=diko8nvte801k4fq26yfb1nev&st=f47a0ieg&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload:"",
                view: false,
              },
            ],
          },
                    {
            title: "Lesson 10.20: Reinforcement Learning (Deep Deterministic Policy Gradient) (2)",
            key: "m10l20",
            video: "https://www.dropbox.com/scl/fi/5sdwpi4s8cs56clkh67yg/M10W05-Reinforcement-Learning-Deep-Deterministic-Policy-Gradient-Zoom-1.mp4?rlkey=z1f31c8woflt56p746qthjkrj&st=jr7u4xnh&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload:"",
                view: false,
              },
            ],
          },
          {
            title: "Lesson 10.21: Vision Language Model",
            key: "m10l21",
            video: "https://www.dropbox.com/scl/fi/5svkz8fkb5qi26ea4rs77/M10W05-Vision-Language-Model-Zoom.mp4?rlkey=t7k48tvp26dbxd4w26qc26ryu&st=s502yym5&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload:"",
                view: false,
              },
            ],
          },
          {
            title: "Lesson 10.22: Project Agentic AI Using Vision Language Model",
            key: "m10l22",
            video: "https://www.dropbox.com/scl/fi/u7bsg2swapsnie6z53b3r/M10W05-Project-Agentic-AI-Using-Vision-Language-Model-Zoom.mp4?rlkey=i2p10055qtfqmxhxf5xbdyj28&st=h687ox1i&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload:"",
                view: false,
              },
            ],
          },
        ],
      },
    },
  },

  MLOps: {
    title: "Machine Learning Ops",
    children: {
      MachineLearning1: {
        title: " Module 1: Fundamentals",
        children: [
          {
            title: "Lesson 0: Setup",
            key: "",
            video: " ",
            document: [
              {
                title: "manifests.zip",
                link: "",
                linkDownload:
                  "https://www.dropbox.com/scl/fo/yo4l2zz1ie5poyo1pgj5x/AEs7sKGFJZPNXCkgc0WIYlE?rlkey=pip3vmsfsd4fy0jis7dt48095&st=eokd3rld&dl=1",
                view: false,
              },
            ],
          },
          {
            title: "Lesson 1: Linux",
            key: "mlops1.1",
            video:
              "https://www.dropbox.com/scl/fi/819fkgbzw3v1lla5hiot2/lesson1-linux.mp4?rlkey=re9y5kmzrujag2zoiyhlfpgkn&st=nruwboyu&raw=1",
            document: [
              {
                title: "linux.pdf",
                link: "https://www.dropbox.com/scl/fi/d6jg5ubborrytsiqi3mmm/lesson1-linux.pdf?rlkey=ac59bqx459wiajusgoue8qnir&st=b9rphue2&raw=1",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/d6jg5ubborrytsiqi3mmm/lesson1-linux.pdf?rlkey=ac59bqx459wiajusgoue8qnir&st=b9rphue2&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 2: Python (2)",
            key: "mlops1.2",
            video:
              "https://www.dropbox.com/scl/fi/8jod9tybj11xeeujlhuqr/lesson2-python.mp4?rlkey=lr5sx8tp7vn5hm6xzcq1baeyz&st=5iec6tds&raw=1",
            document: [
              {
                title: "high-performance-python.zip",
                link: " ",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/r3une3i6fxfuk0iu56ems/high-performance-python.zip?rlkey=louax73u1x55gfopw45shw79u&st=ujnkjwro&dl=1",
                view: false,
              },
              {
                title: "python_tutorials.zip",
                link: " ",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/3a2su1oyauwob50lkz518/python_tutorials.zip?rlkey=auvkq2bvk5xskfeg5xbyzi6ny&st=pn56j6oe&dl=0",
                view: false,
              },
              {
                title: "lesson2&3&4-python.pdf",
                link: "https://www.dropbox.com/scl/fi/j4qxas4dnycpc21qkmct3/lesson2-3-4-python.pdf?rlkey=smmqo3hrjfi0217zhtyhcqlbr&st=xqsrgjoc&dl=0",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/j4qxas4dnycpc21qkmct3/lesson2-3-4-python.pdf?rlkey=smmqo3hrjfi0217zhtyhcqlbr&st=xqsrgjoc&dl=1",
                view: true,
              },
              {
                title: "lesson2&3&4-python(extra).pdf",
                link: "https://www.dropbox.com/scl/fi/4jgrqid6herssux6qbpur/lesson2-3-4-python-extra.pdf?rlkey=88ts0cywzeo5kj01eti0hv77m&st=85ktdmut&dl=0",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/4jgrqid6herssux6qbpur/lesson2-3-4-python-extra.pdf?rlkey=88ts0cywzeo5kj01eti0hv77m&st=85ktdmut&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 3: Python (3)",
            key: "mlops1.3",
            video:
              "https://www.dropbox.com/scl/fi/0bo9mqj73ptf182qlxdby/lesson3-python.mp4?rlkey=zu2hzpk8pwzgnt2o36awc7bwt&st=krjyk1ee&raw=1",
            document: [
              {
                title: "high-performance-python.zip",
                link: " ",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/r3une3i6fxfuk0iu56ems/high-performance-python.zip?rlkey=louax73u1x55gfopw45shw79u&st=ujnkjwro&dl=1",
                view: false,
              },
              {
                title: "python_tutorials.zip",
                link: " ",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/3a2su1oyauwob50lkz518/python_tutorials.zip?rlkey=auvkq2bvk5xskfeg5xbyzi6ny&st=pn56j6oe&dl=0",
                view: false,
              },
              {
                title: "lesson2&3&4-python.pdf",
                link: "https://www.dropbox.com/scl/fi/j4qxas4dnycpc21qkmct3/lesson2-3-4-python.pdf?rlkey=smmqo3hrjfi0217zhtyhcqlbr&st=xqsrgjoc&dl=0",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/j4qxas4dnycpc21qkmct3/lesson2-3-4-python.pdf?rlkey=smmqo3hrjfi0217zhtyhcqlbr&st=xqsrgjoc&dl=1",
                view: true,
              },
              {
                title: "lesson2&3&4-python(extra).pdf",
                link: "https://www.dropbox.com/scl/fi/4jgrqid6herssux6qbpur/lesson2-3-4-python-extra.pdf?rlkey=88ts0cywzeo5kj01eti0hv77m&st=85ktdmut&dl=0",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/4jgrqid6herssux6qbpur/lesson2-3-4-python-extra.pdf?rlkey=88ts0cywzeo5kj01eti0hv77m&st=85ktdmut&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 4: Python (4)",
            key: "mlops1.4",
            video:
              "https://www.dropbox.com/scl/fi/tez308gnx5nmj09nh9ztg/lesson4-python.mp4?rlkey=c7wzc9igy3dqfvtx3nq3nakpz&st=d29668yi&raw=1",
            document: [
              {
                title: "high-performance-python.zip",
                link: " ",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/r3une3i6fxfuk0iu56ems/high-performance-python.zip?rlkey=louax73u1x55gfopw45shw79u&st=ujnkjwro&dl=1",
                view: false,
              },
              {
                title: "python_tutorials.zip",
                link: " ",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/3a2su1oyauwob50lkz518/python_tutorials.zip?rlkey=auvkq2bvk5xskfeg5xbyzi6ny&st=pn56j6oe&dl=0",
                view: false,
              },
              {
                title: "lesson2&3&4-python.pdf",
                link: "https://www.dropbox.com/scl/fi/j4qxas4dnycpc21qkmct3/lesson2-3-4-python.pdf?rlkey=smmqo3hrjfi0217zhtyhcqlbr&st=xqsrgjoc&dl=0",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/j4qxas4dnycpc21qkmct3/lesson2-3-4-python.pdf?rlkey=smmqo3hrjfi0217zhtyhcqlbr&st=xqsrgjoc&dl=1",
                view: true,
              },
              {
                title: "lesson2&3&4-python(extra).pdf",
                link: "https://www.dropbox.com/scl/fi/4jgrqid6herssux6qbpur/lesson2-3-4-python-extra.pdf?rlkey=88ts0cywzeo5kj01eti0hv77m&st=85ktdmut&dl=0",
                linkDownload:
                  "https://www.dropbox.com/scl/fi/4jgrqid6herssux6qbpur/lesson2-3-4-python-extra.pdf?rlkey=88ts0cywzeo5kj01eti0hv77m&st=85ktdmut&dl=1",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 5:  Bash Script",
            key: "mlops1.5",
            video: "https://www.dropbox.com/scl/fi/j1g77rzqucztetpn01j0u/lesson5-bashscript.mp4?rlkey=94508dkp9inayfv4po1o91y02&st=2mlkqwmg&raw=1",
            document: [
              {
                title: "Lesson 5 - Bash Script.pptx",
                link: "https://www.dropbox.com/scl/fi/pmwi8caf4rnrq9wxd6gpc/Lesson-5-Bash-Script.pptx?rlkey=mh1sbp6j4xxgq9vfjg7povhil&st=osrsk4er&raw=0",
                linkDownload: "https://www.dropbox.com/scl/fi/pmwi8caf4rnrq9wxd6gpc/Lesson-5-Bash-Script.pptx?rlkey=mh1sbp6j4xxgq9vfjg7povhil&st=osrsk4er&dl=1",
                view: true,
              },
              {
                title: "bash_scripting.zip",
                link: " ",
                linkDownload: "https://www.dropbox.com/scl/fi/146jtts2etxkugg0nuk0u/bash_scripting.zip?rlkey=63420bu2k9k7hv28wwa0v8eij&st=o4a55idq&dl=1",
                view: false,
              },
              {
                title: "ebay_deals_crawler.zip",
                link: " ",
                linkDownload: "https://www.dropbox.com/scl/fi/e4gbo0irrimult1ta051i/ebay_deals_crawler.zip?rlkey=0afx7mizrgs2jb6ewtvrvdion&st=xq3cy4ta&dl=1",
                view: false,
              },
            ],
          },
          {
            title: "Lesson 6: Web API (6)",
            key: "mlops1.6",
            video: "https://www.dropbox.com/scl/fi/zwxg8osfcxru2jz9bz5ev/lesson6-webapi.mp4?rlkey=e5vwev1xkh4v27syee85irx4r&st=qtontidt&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 7: Web API (7)",
            key: "mlops1.",
            video: "https://www.dropbox.com/scl/fi/pi4dn1daen194tf4ynmj5/lesson7-webapi.mp4?rlkey=pn5wpg7jy7z769m2zycvl46iy&st=0v7eg4ru&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 8: Docker (8)",
            key: "mlops1.8",
            video: "https://www.dropbox.com/scl/fi/62jd647f12csw974n7z0u/lesson8-docker.mp4?rlkey=pvmx089n8pnnmn6pem8f36ed8&st=vegobleb&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 9: Docker (9)",
            key: "mlops1.9",
            video: "https://www.dropbox.com/scl/fi/4mf9f1fh1eq6s5rzyp6rh/lesson9-docker.mp4?rlkey=r9mbpduekglsqk2ev5ri4vaxc&st=zced14z6&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 10: Kubernetes (k8s)",
            key: "mlops1.10",
            video: "https://www.dropbox.com/scl/fi/tg079ebl7f8q2cspyih3t/lesson10-kubernetes-k8s.mp4?rlkey=2bjdjfppkzq1663plom8gjccg&st=j17djbkf&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 11: Cloud Services",
            key: "mlops1.11",
            video: "https://www.dropbox.com/scl/fi/pjd51e1tn3cisn8wmd9vd/lesson11-CloudServices.mp4?rlkey=669nwqfks3rd747tjsytlfj1v&st=jltpibdx&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 12: CICD",
            key: "mlops1.12",
            video: "https://www.dropbox.com/scl/fi/m8jasp0n4yf9kwrl2rdl9/lesson12-CICD.mp4?rlkey=p3g8i4yjkwpmsj6gerbkai9eh&st=j2h814vk&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 13: IaC",
            key: "mlops1.",
            video: "https://www.dropbox.com/scl/fi/kcic2ays53mldqhlfrel5/lesson13-IaC.mp4?rlkey=whqj0p9no6rdr0xll7h258edx&st=fjzqymlu&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 14: Observable System (14)",
            key: "mlops1.14",
            video: "https://www.dropbox.com/scl/fi/uyjjifa6d0ei9wiwhy4jt/lesson14-OvserableSystem.mp4?rlkey=ab93l1bvl1twli59in2nnz1s7&st=9081xad5&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson 15: Observable System (15)",
            key: "mlops1.15",
            video: "https://www.dropbox.com/scl/fi/1s3e2ppij7wjyfoljp8re/lesson15-OvserableSystem.mp4?rlkey=x22eywpyvt2kybaydg9s0td67&st=885yriko&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
          {
            title: "Lesson Final: Lựa chọn đề tài cuối khoá",
            key: "mlops1.16",
            video: "",
            document: [
              {
                title: "",
                link: "",
                linkDownload: "",
                view: true,
              },
            ],
          },
        ],
      },
      MachineLearning2: {
        title: "Module 2: Data Engineering",
        children: [
          {
            title: "Lesson 16: Data Architecture",
            key: "l16",
            video: "https://www.dropbox.com/scl/fi/9azwvm55pzwjrvrih6fko/Lesson16-DataArchitecture.mp4?rlkey=b91yqe4v9u4za0u7chvj6a3b6&st=48fzfy7l&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 17: Source Systems",
            key: "l17",
            video: "https://www.dropbox.com/scl/fi/7by2q3ypw1fynn001ln6k/Lesson17-SourceSystems.mp4?rlkey=packs5k9bimb0coi2pos0h023&st=hb4cow8i&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 18: Source Systems",
            key: "l18",
            video: "https://www.dropbox.com/scl/fi/rftc4wmlewoowre4nerok/Lesson18-SourceSystems.mp4?rlkey=t736625wdp4urmlbl74ue7g4p&st=9xmcl8px&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 19: Storage",
            key: "l19",
            video: "https://www.dropbox.com/scl/fi/d2lv804rb5dpvb0ge5mvt/Lesson19-Storage.mp4?rlkey=ir4mqijok9n99n4rac5xpybdx&st=qyauutvz&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 20: Batch Processing",
            key: "l20",
            video: "https://www.dropbox.com/scl/fi/cnji2lforeuzki96dyo18/Lesson20-BatchProcessing.mp4?rlkey=7c899k4dnubnkso8q89wr1aty&st=so3tslci&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 21: Batch Processing",
            key: "l21",
            video: "https://www.dropbox.com/scl/fi/xzkcp2y32t8gw9ynpdogj/Lesson21-BatchProcessing.mp4?rlkey=zd02iwga8jphoxmm9lk4zpddb&st=mtgtd1zw&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 22: Stream Processing",
            key: "l22",
            video: "https://www.dropbox.com/scl/fi/eg2wso6ij80qbnjlezk08/lesson22-StreamProcessing.mp4?rlkey=ykmppxbesabrdd5eetq8pqmj4&st=1d2b11xr&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 23: Stream Processing",
            key: "l23",
            video: "https://www.dropbox.com/scl/fi/as3a4urcryz8ej6f2dkco/Lesson23-StreamProcessing.mp4?rlkey=wq1w2j1z2dgit13ny4zcixi9x&st=lm9ggj0l&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 24: Pipeline Orchestration",
            key: "l24",
            video: "https://www.dropbox.com/scl/fi/yon9ev98sd8cjz75881yh/Lesson24-PipelineOrchestration.mp4?rlkey=1fnfpv3opwpvx68rvgoofr84l&st=52t9j1kb&raw=1",
            document: [
              {
                title: "",
                link: "",
                linkDownload:"",
                view: false, 
              },
            ],
          },
          {
            title: "Lesson Final",
            key: "lf2",
            video: " ",
            document: [
              {
                title: "",
                link: "",
                linkDownload:"",
                view: false, 
              },
            ],
          },
        ],
      },
      MachineLearning3: {
        title: "Module 3: Advanced MLOps",
        children: [
          {
            title: "Lesson 25: Fundamental of Software Architecture",
            key: "l25",
            video: "https://www.dropbox.com/scl/fi/k9tyb8xics1d5s4ilpzj7/Lesson25-FundamentalofSoftwareArchitecture.mp4?rlkey=cknilbzetjyx1e84qw9l2b7cx&st=b8jgxfds&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 26: CRISP-ML(Q)",
            key: "l26",
            video: "https://www.dropbox.com/scl/fi/uf989jy9c7x336nxrs42f/Lesson26-CRISP-ML-Q.mp4?rlkey=4ey0aws1zyubc0m9wv0ziq5wm&st=xyykyxi0&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 27: CRISP-ML(Q)",
            key: "l27",
            video: "https://www.dropbox.com/scl/fi/hxjo84tsyk7ksgvuv39o6/Lesson27-CRISP-ML-Q.mp4?rlkey=atd8leyfhb0xprhrp2jmy7vii&st=gm5pn5bp&raw==1",
            document: [
              
            ],
          },
          {
            title: "Lesson 28: Model Training & Serving Design Patterns",
            key: "l28",
            video: "https://www.dropbox.com/scl/fi/xlscm7d0oknisgic4h68b/Lesson28-ModelTraining-ServingDisignPatterns.mp4?rlkey=3s5w3p5vyjgv1wsrcezafcdo6&st=u8dgi0ic&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 29: Model Training & Serving Design Patterns",
            key: "l29",
            video: "https://www.dropbox.com/scl/fi/f10wvqd6z1d77fmlx2eff/Lesson29-ModelTraining-ServingDisignPatterns.mp4?rlkey=fhnnjdgpgtnv38s7c61cs833c&st=zbgbxgmu&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 30: Serverless Inference",
            key: "l30",
            video: "https://www.dropbox.com/scl/fi/ygm9sjggdqsu94tsucm9p/Lesson30-ServerlessInference.mp4?rlkey=4qgbjbkdaqdf0x6cnutpd3480&st=yskqpcow&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 31: Serverless Inference",
            key: "l31",
            video: "https://www.dropbox.com/scl/fi/oxn73uwbastpf4pkncfgn/Lesson31-ServerlessInference.mp4?rlkey=q4y22wdavgjr4jznits30zper&st=xi6a0b7m&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 32: High Density Model Serving",
            key: "l32",
            video: "https://www.dropbox.com/scl/fi/j25t8b3g5ja8ang2a6t84/Lesson32-HighDensityModelServing.mp4?rlkey=1fgztaxuxwx10yvr00mmvqaal&st=delamo34&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 33: High Density Model Serving",
            key: "l33",
            video: "https://www.dropbox.com/scl/fi/drvobb3tpi56u7rcej30f/Lesson33-HighDensityModelServing.mp4?rlkey=rfoo5mard6hhkhl59isffxm3l&st=gk028bjs&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 34: Kubeflow",
            key: "l34",
            video: "https://www.dropbox.com/scl/fi/2k2wpnfugneymdmdjh3xd/Lessson34-MLSystemDesign-MLOps.mp4?rlkey=7n3rhxpe0f6ux41xcm9p8f0zy&st=jialdu7r&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 35: Feature Store",
            key: "l35",
            video: "https://www.dropbox.com/scl/fi/bvm7wtiq8zldbzznrlolm/Lesson35-Kubeflow.mp4?rlkey=rnmjkn9nr7g87glcj43up8utd&st=5sz1t9rj&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 36: ML System Design & MLOps",
            key: "l36",
            video: "https://www.dropbox.com/scl/fi/p9wh9vilc8p1u3lbtirwp/Lesson36-FeatureStore.mp4?rlkey=a0amxrdjvnhjntvybh3smevs0&st=rmwo4gio&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 37: ML System Design & MLOps",
            key: "l37",
            video: "https://www.dropbox.com/scl/fi/txm2wims6ky2abwlc0t5q/Lesson37-MLSystemDesign-MLOps.mp4?rlkey=jut4yxzupirlzghwzxj6bua60&st=0swit1ug&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson Final: Lựa chọn đề tài cuối khóa",
            key: "lf3",
            video: " ",
            document: [
              
            ],
          },

        ],
      },
      MachineLearning4: {
        title: "Module 4: Supplementary",
        children: [
          {
            title: "Lesson 38: Design Pattern",
            key: "mlops38",
            video: "https://www.dropbox.com/scl/fi/81j8rpv201ymrqn2fj2u6/design_pattern.mp4?rlkey=n5co2omlzv4fxgy3aeuppd19z&st=ifxic7c6&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 39: Data Validation with Great Expectations and Deequ",
            key: "mlops39",
            video: "https://www.dropbox.com/scl/fi/zc5bh3k2sj8a8vceem7pj/data_validation.mp4?rlkey=pxvbxjzgy6f79ab49p90lbknx&st=1kfd4r6g&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 40: Function Testing",
            key: "mlops40",
            video: "https://www.dropbox.com/scl/fi/36lzgrp0yyxbkgi82loe7/lesson40-FunctionalTesting.mp4?rlkey=rnksbc9x081d95zyji6b6ub39&st=2aes8x8d&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 41: DataHub (metadata platform) & data governance",
            key: "mlops41",
            video: "https://www.dropbox.com/scl/fi/h3r05qjq3ksny0145exi3/datahub_metadata.mp4?rlkey=ojr6aucj8zmok4a1b41zbjigq&st=nd2wh5br&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 42: Distributed Training On K8S",
            key: "mlops42",
            video: "https://www.dropbox.com/scl/fi/c5kd7j9bakdfgu36r1ufa/distributed_training.mp4?rlkey=8oke89dejwdd4oqg78gfx44c1&st=ztby0y6r&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 43: Database Manipulation with ORM",
            key: "mlops43",
            video: "https://www.dropbox.com/scl/fi/q5k0iihh2e0jql3h1khci/database_manipulation.mp4?rlkey=gexek4a0k8d6ebh4tp69zexnu&st=sc0g6fzp&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 44: Git & GitFlow",
            key: "mlops44",
            video: "https://www.dropbox.com/scl/fi/ybm10peimt0jv5hjij4ns/lesson41-GitAndGitflow.mp4?rlkey=sezx73gjmvub8e8voq5gu4pye&st=w8p9rlhl&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 45: API Gateway & NGINX",
            key: "mlops45",
            video: "https://www.dropbox.com/scl/fi/exxwl7ihoajkqijetmhud/lesson39-APIGateway-NGINX.mp4?rlkey=n86zy3v6bjmcjac2wt6blj661&st=oelcttv0&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 46: gRPC",
            key: "mlops46",
            video: "https://www.dropbox.com/scl/fi/ufu0drgt3f52y87htbggo/intrusion_detection.mp4?rlkey=wop92htlj28492l1s6003by31&st=5oef30w7&raw=1",
            document: [
              
            ],
          },
          {
            title: "Lesson 46: gRPC (1)",
            key: "mlops47",
            video: "https://www.dropbox.com/scl/fi/ihau6bsk5kk0eab0z6cjy/interage_mlops_flow.mp4?rlkey=yg60a9tpsfscc63as9u8j4t8n&st=eaycs2td&raw=1",
            document: [
            ],
          },
        ],
      },
  },
}};

// MachineLearning: {
//     title: "5. Steps to Deep Learning",
//     children: [
//         {
//             title: "",
//             key: "",
//             video: " ",
//             document: [
//                 {
//                     title: "",
//                     link: "",
//                     linkDownload: "",
//                     view: true,
//                 },
//             ],
//         },

//     ],
// }
